
import React, { useState, useEffect, use } from 'react';
import CardPayment from '../../PaymentPost/CardPayment'
import QRCode from "react-qr-code";
import { Tabs, Tab } from 'react-bootstrap';

import { FilterOrderFetchAPI } from '../../../api/Paymentpost/FilterOrder';
import { PaymentMethodFetchAPI } from '../../../api/Paymentpost/PaymentMethod';
import { AuthDgiFetchAPI } from '../../../api/Paymentpost/AuthDgi';
import { RequestLocalFetchAPI } from '../../../api/Paymentpost/RequestLocal';
import { ReservationFetchAPI } from '../../../api/reservation';
import { PrintOrderLocalFetchAPI } from '../../../api/Paymentpost/PrintOrder';
import { OrderNumberFetchAPI } from '../../../api/Paymentpost/OrderNumber';
import { CashTempPosFetchAPI } from '../../../api/Paymentpost/OrderTemporalCash';
import { CategriesPosFetchAPI } from '../../../api/Paymentpost/CategoriesPos';
import { DeletedTempOrdersFetchAPI } from '../../../api/DeletedTemporalOrders';
import { ClientsFetchAPI } from '../../../api/Clients';
import { YappyFetchAPI } from '../../../api/Paymentpost/Yappy'
import ModalPhoneSaveYappy from './Yappy/ModalPhoneSaveYappy';
import Modal from 'react-bootstrap/Modal'
import ModalConfirmation from '../../PaymentPost/ModalConfirmation';
import ModuleLocator from '../../Locator/ModuleLocator';
import ModalPaymentMixto from './MixPay/ModalPaymentMixto';
import ModalPaymentManual from '../../PaymentPost/ModalPaymentManual';
import ModalYappyQrPos from '../../PaymentPost/ModalYappyQrPos';
import Modalclient from '../../PaymentPost/ModalClients';
import ModuleTips from '../../Tips/ModuleTips';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import ErrorAlert from '../../Alerts/ErrorAlert';
import AlertSmall from '../../Alerts/AlertSmall';
import LoadingAlert from '../../Alerts/LoadingAlert';
import ConfirmationAlert from '../../Alerts/ConfirmationAlert';
import { PreOrderFetchAPI } from '../../../api/Paymentpost/PreOrder';
import Cashierpost from '../../cahsier/Cashierpost';
import { MachinesFetchAPI } from '../../../api/Machines';
import { PrinterFetchAPI } from '../../../api/Printer';
import { MicrosFetchAPI } from '../../../api/Micros';
import { OrdersFetchAPI } from "../../../api/Orders"
import { InventoryFechtAPI } from '../../../api/Inventory';
import { RequestAlohaFetchAPI } from '../../../api/Paymentpost/RequestAloha';
import { DeliveryOrdersFetchAPI } from '../../../api/DeliveryOrders';
import moment from 'moment-timezone';

import printOrderData from '../../PaymentPost/PrintOrderData';
import ModalCallCenter from './OnlinePay/ModalCallCenter';

import ModalDonlee from '../../DonLee/ModalDonlee';
import ClientPillCard from '../../ClientPillCard/ClientPillCard';
import RecoveryOrderApproved from '../../PaymentPost/RecoveryOrderApproved';

import ModalWaiters from '../../Waiters/ModalWaiters';
//Sweet alert
import Swal from "sweetalert2";

//Img
import payOnline from "../../PaymentPost/img/Payonline.png"
import empty_img from '../../PaymentPost/img/Payonline.png';
import checkimg from '../../PaymentPost/img/check.png';
import cancel from '../../PaymentPost/img/cancel.png'
import sadImg from '../../PaymentPost/img/sad.png'
import loading from '../../PaymentPost/img/loading.gif'
//Icons 
import { FaCcVisa, FaPhoneAlt } from 'react-icons/fa';
import SuccessAlert from '../../Alerts/SuccessAlert';
//Utils
import { buildCloudinaryImageUrl } from '../../../utils/CloudinaryImageUrl';
import { generateToken } from '../../../utils/GenerateToken';
import { RenderIf } from '../../utils/RenderIf';
import Socket from '../../utils/Socket.config';
import { ProcessPayment } from '../../../utils/ProcessPayment';
import { PaymentOperations } from '../../../utils/PaymentOperations';
import { ClearPhone } from '../../../utils/ClearPhone';
import { printData } from '../../../utils/PrintData';
import { normalizeApiError, showApiError } from '../../../utils/ApiError';
import { hasPendingKitchenItems, hasPreOrderCode, shouldUsePreOrderPaymentPrintMode } from '../../../utils/PreOrderPaymentPrint';
import Empty from '../../utils/Empty';
import './ModalPayMet.css'
import PayMethodsCarousel from './PayMethodsCarousel';
import CashKeypad from './CashKeypad';

// Normalize waiter shape to the one we use in POS flow
// Expected: { user_id, user_name, user_code }
const normalizeWaiter = (waiterLike) => {
  if (!waiterLike) return null
  const user_id = waiterLike.user_id ?? waiterLike.id ?? waiterLike.waiter_id ?? null
  const user_name = waiterLike.user_name ?? waiterLike.name ?? waiterLike.waiter_name ?? null
  const user_code = waiterLike.user_code ?? waiterLike.code ?? waiterLike.waiter_code ?? null
  if (!user_id) return null
  return { user_id, user_name, user_code }
}



const ModalPayMet = ({
  selectPreOrder,
  baseReducedTax,
  selectedDeliveryRule,
  invoiceTaxDeliveryFee,
  preOrderInvoice, dv, name, ruc, setDv, setName,
  setRuc, dataResponse, optionalData, setDataResponse,
  setOptionalData, shoppingCart, shoppingCartCombos,
  total, subtotal, discount, tax, setPageLoader, delivery,
  dataPreOrder, checkDeliveryOrder, registerTurnOrder,
  setRegisterTurnOrder, client_phone, setClient_phone,
  locator, setLocator, dataClient, setDataClient,
  listPaymentReady, setlistPaymentReady, amountPaymentReady,
  setAmountPaymenReady, tableInfo, taxesArrayAll, dataDicountApply,
  invoiceTips, setInvoiceTips, moduleTips, recomendationTips, totaltopay,
  setEventHandler, pos_integration_name, dataReferenceOrderMicros, parthner_order, parthners,
  codeParthner, yappy_transaction_id, setYappy_transaction_id, showModuleLocator,
  cardGroup, paramsMicros, dataClientSelected, setdataClientSelected,
  addressNowLocation, setAddressNowLocation, businessLogo, domain, enabledOnlineOrder,
  setShoppingCart, calculateInvoiceTotals, recoveryOrderApproved, setRecoveryOrderApproved,
  selectRestaurant, setResetData, setShoppingCartCombos, orderNumber, setOrderNumber, orderNumberNow, setOrderNumberNow,
  dataStyleBusiness, sendMail, sendStatus, aditional_data, setAditional_data, addresDescriptionClientFiscal, setAddresDescriptionClientFiscal,
  eventDataState, events, eventSelect, hasPendingPreOrderCartChanges, isPointsPayment = false, pointsTotal = 0
}) => {

  //States
  const [paymentMethod, setPaymentMethod] = useState([])
  const [show, setShow] = useState(false);
  const [showModalProcess, setShowModalProcess] = useState(false);
  const [showModalPhone, setShowModalPhone] = useState(false);
  const [showModalPageYappy, setShowModalPageYappy] = useState(false);
  const [printers, setPrinters] = useState([]);
  const [microsModule, setMicrosModule] = useState(0)
  const [dataPrint, setDataPrint] = useState({})
  const [txtErrorRegisterOrder, setTxtErrorRegisterOrder] = useState("")


  const [showEditBill, setShowEditBill] = useState(false);
  const handleEditBillClose = () => setShowEditBill(false);
  const handleEditBillShow = () => setShowEditBill(true);


  //cashier states
  const [emailInput, setEmailInput] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [modalShowErrorRegisterOrder, setModalShowErrorRegisterOrder] = useState(false)
  const [detailOrder, setDetailOrder] = useState();
  const [amountOrder, setAmountOrder] = useState();
  const [showModalInsufficientFunds, setShowModalInsufficientFunds] = useState(false);
  const [insufficientMessage, setInsufficientMessage] = useState("");
  const [paymentInfo, setPaymentInfo] = useState({ payment: "" })
  const [showModalMixto, setShowModalMixto] = useState(false)
  const [showPaymentManual, setPaymentManual] = useState(false)
  const [datatransaction_code, setDataTransaction_code] = useState("");
  const [order_id, setOrder_id] = useState("");
  const [order_code, setOrderCode] = useState("");
  const [client_type, setClient_type] = useState(0);
  const [dgiUrl, setDgiUrl] = useState("");
  const [cufe, setCufe] = useState("");
  //const [orderNumber, setOrderNumber] = useState("0")
  //const [orderNumberNow, setOrderNumberNow] = useState("0")
  const [orderNumbeTemp, setOrderNumberTemp] = useState({ code: "", temp_id: "" })
  const [responseQr, setResponseQr] = useState(false)
  const [paymentApproval, setPaymentApproval] = useState({ status: 0, description: "Procesando pago" })
  const [windows_ip, setWindows_ip] = useState("");
  const [infoPrinter, setInfoPrinter] = useState({ printer_comanda: "", printer_ticket: "", printer_ip: "" })
  const [EMVStreamResponse, setEMVStreamResponse] = useState({ EMVStreamResponse: "" })
  const [change, setChange] = useState(0);
  const [tempMethodPayment, setTempMethodPayment] = useState(0)
  const [amountPending, setAmountPending] = useState(0)
  const [lastOrder_id, setLastOrder_id] = useState("");
  const [orderToRecovery, setOrderToRecovery] = useState(null);
  const [showModalWaiters, setShowModalWaiters] = useState(false);
  const [selectedWaiter, setSelectedWaiter] = useState(null);
  const [pendingOpenPayment, setPendingOpenPayment] = useState(false);
  const [pointsRedeemLoading, setPointsRedeemLoading] = useState(false);
  //Cashback states
  const [cashback, setCashback] = useState(0);
  const [cashbackModal, setCashbackModal] = useState(false);

  //Yappy QR
  const [statePayment, setStatePayment] = useState(false);
  const [modalYappyQr, setModalYappyQr] = useState(false);
  const [dataYappy, setDataYappy] = useState({});
  const [dataHash, setDataHash] = useState("");
  const [statusRequestYappy, setStatusRequestYappy] = useState(false);

  const [contAuthRuc, setCountAucthRuc] = useState(0)

  let ventanaYappy = 0;

  // Devuelve la fecha y hora actual en formato 'YYYY-MM-DD HH:mm:ss'
  function getCurrentDateTime() {
    const now = new Date();
    const pad = (n) => n.toString().padStart(2, '0');
    const year = now.getFullYear();
    const month = pad(now.getMonth() + 1);
    const day = pad(now.getDate());
    const hours = pad(now.getHours());
    const minutes = pad(now.getMinutes());
    const seconds = pad(now.getSeconds());
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  //avi-ina
  const [botonDeshabilitado, setBotonDeshabilitado] = useState(false);

  let machine = localStorage.getItem('machine');
  let business = localStorage.getItem('business');

  //We validate if the machine is logged in
  if (business !== null && business !== undefined && business !== '') {
    business = JSON.parse(localStorage.getItem('business'))
  }

  //We validate if the machine is logged in
  if (machine !== null && machine !== undefined && machine !== '') {
    machine = JSON.parse(localStorage.getItem('machine'))
  }


  let instervalCash = 0

  //Functions to show and hide the modal cashier
  const handleCloseModal = () => setModalShow(false);
  const handleShowModal = () => setModalShow(true)

  //get client by business 
  const getClientsByBusiness = async () => {
    let token = localStorage.getItem('x-access-machine-token');
    return new Promise(async (resolve, reject) => {
      try {

        let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
        let business_id = business.id
        if (parthner_order == true) {
          business_id = branchoffice.parthner_business
        }
        const response = await ClientsFetchAPI.getClientsByBusiness(business_id, token);
        resolve(response.data.data);
      } catch (err) {

        reject(err);
      }
    });
  }

  //create client in the business
  const createClient = async (name, dv, typeRuc, client_type) => {
    let token = localStorage.getItem('x-access-machine-token');
    let data = {
      "phone": "6000-0000",
      "name": name,
      "billing_name": name,
      "business_code": business.code,
      "client_type_id": client_type,
      "gender": "Masculino",
      "client_ruc_type": typeRuc,
      "ruc": ruc,
      "dv": dv,
      "location": "0",
      "is_validated": 1,
      "password": "123456789",
      "passwordCheck": "123456789",
    }


    let DataGeneral = JSON.parse(localStorage.getItem('generalData'))
    let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
    if (parthner_order == true) {
      DataGeneral.forEach((business) => {

        if (business.data.business.id == branchoffice.parthner_business) {
          data.business_code = business.data.business.code
        }
      })
    }
    try {
      const response = await ClientsFetchAPI.createClient(data, token)
    } catch (err) {

    }
  }


  //Validate that the client already exists, if it does not exist, send it to validate with the dgi
  const validDataClient = async () => {
    let getClients = {}

    try {
      getClients = await getClientsByBusiness();
    } catch (err) {
      getClients = [{ ruc: "0" }]
    }
    let ruc_client = ruc
    const result = getClients.find(({ ruc }) => ruc === ruc_client);


    if (result === undefined) {
      authenticationDgi()
    } else {
      if (result.billing_name !== null && result.billing_name !== "" && result.billing_name !== undefined) {
        setName(result.billing_name)
        setDv(result.dv)
        setDataResponse(true)
      } else {
        authenticationDgi(result)
      }
    }
  }

  const getClientType = async (dTipoRec) => {
    let token = localStorage.getItem('x-access-machine-token');
    try {
      const responseTypeClient = await ClientsFetchAPI.getClientType(token)

      let dataTypes = responseTypeClient.data.data;

      let dataNow = dataTypes.find(type => type.name.toLowerCase() == dTipoRec.toLowerCase())
      if (dataNow != undefined) { return dataNow.id } else { return 2 }
    } catch (err) {

      return 2;
    }
  }

  //function to authentication of ruc
  const authenticationDgi = async (dataclientUpdate) => {
    let message = ""
    let title = ""
    let icon = ""
    if (ruc == "") {
      message = "No se ha ingresado ningun ruc."
      title = "Debes ingresar un ruc."
      icon = "warning"
      ErrorAlert(message, title, icon)
    } else {
      LoadingAlert()
      let token = localStorage.getItem('x-access-machine-token');
      let data = { ruc: ruc }
      try {
        const response = await AuthDgiFetchAPI.authenticationRuc(token, data)
        let dataDgi = response.data
        let dTipoRec = dataDgi?.dgi_response?.dTipoRec ? dataDgi.dgi_response.dTipoRec : "Consumidor final"
        let clientType = await getClientType(dTipoRec)
        setClient_type(clientType)

        if (dataDgi.dgi_response.gResProc) {
          if (dataDgi.dgi_response.gResProc.dCodRes == "0680") {
            let dvDgi = dataDgi.dgi_response.dDV
            if (dvDgi.length < 2) { dvDgi = "0" + dvDgi }
            setName(dataDgi.dgi_response.dNomb)
            setDv(dvDgi)
            message = "Datos del clientes obtenidos por la DGI"
            title = "Datos obtenido correctamente"
            icon = "success"
            ErrorAlert(message, title, icon)
            setDataResponse(true);

            //We proceed to create or update the client
            if (dataclientUpdate !== undefined) {
              updateClient(dataDgi.dgi_response.dNomb, dvDgi, dataDgi.dgi_response.dTipoRuc, clientType, dataclientUpdate)
            } else {
              createClient(dataDgi.dgi_response.dNomb, dvDgi, dataDgi.dgi_response.dTipoRuc, clientType)
            }

            setCountAucthRuc(0)
          } else {

            if (contAuthRuc < 1) {
              message = "Intente nuevamente."
              title = "Datos no encontrados"
              icon = "warning"
              ErrorAlert(message, title, icon)
              setCountAucthRuc((contAuthRuc + 1))
            } else {
              setOptionalData(true)
              message = "Ingrese los datos manualmente."
              title = "Datos no encontrados"
              icon = "warning"
              ErrorAlert(message, title, icon)
              setCountAucthRuc(0)
            }

            message = "Ingrese los datos manualmente."
            title = "Datos no encontrados"
            icon = "warning"
            ErrorAlert(message, title, icon)

          }
        }
      } catch (err) {

        setOptionalData(true)
        message = "Ingrese los datos manualmente."
        title = "Datos no encontrados"
        icon = "warning"
        ErrorAlert(message, title, icon)
        setCountAucthRuc(0)
      }
    }
  }

  //function to update client info
  const updateClient = async (billing_name, dv, typeRuc, clientType, dataclientUpdate) => {
    let token = localStorage.getItem('x-access-machine-token')
    let business = JSON.parse(localStorage.getItem('business'))
    let data = { billing_name: billing_name, dv: dv, client_type_id: clientType, business_code: business.code, client_ruc_type: typeRuc, };
    try {
      const response = await ClientsFetchAPI.updateClient(data, dataclientUpdate.id, token)

    } catch (err) {

    }

  }

  // get order number in process
  /*const getOrderNumber = async (branchoffice_id, token) => {
    try {
      const response = await OrderNumberFetchAPI.getOrderNumber(branchoffice_id, token)

      setOrderNumber(response.data.next_transaxtion_code);
      setOrderNumberNow(response.data.next_transaxtion_code);

      //setOrderNumber((parseInt(response.data.last_transaction_code) + 1));
      //setOrderNumberNow((parseInt(response.data.last_transaction_code) + 1));
    } catch (err) {

    }
  }*/

  //function get payment method by machine
  const getPaymentMethod = async (machine_id, token) => {
    try {
      const response = await PaymentMethodFetchAPI.getPaymentMethod(machine_id, token);
      setPaymentMethod(Array.isArray(response.data.data) ? response.data.data : []);
    } catch (error) {

    }
  }

  //save info of payment
  const selectPayment = (e) => {
    let token = localStorage.getItem('x-access-machine-token');
    let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
    const option = JSON.parse(e.target.value);
    setSelectedPayment(option);

    //getOrderNumber(branchoffice.id, token)
    if (e.target.checked == true) {
      let payment = JSON.parse(e.target.value)
      setPaymentInfo(payment)
    }
  }

  const getClientAvailablePoints = (client) => {
    const points = parseFloat(client?.points);
    return Number.isFinite(points) ? points : 0;
  }

  const hasEnoughPointsForOrder = (client = dataClientSelected) => {
    return getClientAvailablePoints(client) >= Number(pointsTotal || 0);
  }

  const getPointsPaymentInfo = () => {
    const creditPayment = paymentMethod.find((method) => method.payment === "Credito") || {};
    const integration = creditPayment.integration || { id: 3, name: "Manual" };

    return {
      ...creditPayment,
      payment: "Credito",
      payment_id: creditPayment.payment_id || creditPayment.id || 10,
      id: creditPayment.id || creditPayment.payment_id || 10,
      integration,
      points_payment: true,
      points_total: pointsTotal,
      points_payment_note: `Pago con puntos: ${pointsTotal} pts`
    }
  }

  const getZeroPointsTax = () => ({
    tax_id: 4,
    tax: "0%",
    taxtValue: 0,
    dTasaITBMSValue: "00",
    percentage: "0%",
    total: 0
  })

  const formatPointsOrderItem = (item) => {
    if (!item) return item;

    const zeroMoneyFields = {
      price: 0,
      base_price: 0,
      valueOriginal: 0,
      unit_discount: 0,
      product_discount: 0,
      descuento: 0,
      discount: 0,
      suggested_price: 0,
      total: 0,
      subtotal: 0,
      total_product: 0
    };

    return {
      ...item,
      ...zeroMoneyFields,
      taxes: [getZeroPointsTax()],
      paid_with_points: true,
      points_total: item.points_total || item.points_value || 0,
      segments: Array.isArray(item.segments)
        ? item.segments.map((segment) => ({ ...segment, ...zeroMoneyFields, taxes: [getZeroPointsTax()] }))
        : item.segments,
      DetalleSegmentos: Array.isArray(item.DetalleSegmentos)
        ? item.DetalleSegmentos.map((segment) => ({ ...segment, ...zeroMoneyFields, taxes: [getZeroPointsTax()] }))
        : item.DetalleSegmentos,
      groups: Array.isArray(item.groups)
        ? item.groups.map((group) => formatPointsOrderItem(group))
        : item.groups
    };
  }

  const redeemFrequentShopperPoints = async ({ clientId, points, orderId }) => {
    const token = localStorage.getItem('x-access-machine-token');
    return ClientsFetchAPI.manageFrequentShopperPoints(clientId, {
      points,
      action: "remove",
      order_id: orderId,
      description: `Canje POS orden ${orderNumber}`
    }, token);
  }

  const processPointsPayment = async () => {
    if (!dataClientSelected?.id) {
      ErrorAlert("Debes seleccionar o crear un cliente para validar sus puntos.", "Cliente requerido", "warning");
      return;
    }

    if (!hasEnoughPointsForOrder(dataClientSelected)) {
      ErrorAlert("El cliente no tiene suficientes puntos para esta venta.", "Puntos insuficientes", "warning");
      return;
    }

    setPointsRedeemLoading(true);
    const pointsPaymentInfo = getPointsPaymentInfo();
    setPaymentInfo(pointsPaymentInfo);

    formatDataOrder(0, true, pointsPaymentInfo, dataClientSelected, {
      points_payment: {
        client_id: dataClientSelected.id,
        points: pointsTotal
      }
    });
  }

  //function process payment of the order
  const processPayment = async () => {
    let title = 'Cargando....'
    let message = 'Cargando información....<br/> <br/>'
    let namePayment = paymentInfo.payment
    //-----------------------------------------------------
    setBotonDeshabilitado(true);
    if (namePayment != "") {
      if ((shoppingCart.length + shoppingCartCombos.length) > 0) {
        if (namePayment == 'Efectivo' || namePayment == 'PCCCOIN') {
          title = 'Esperando aprobacion....'
          message = 'El administrador esta aprobando el pago....<br/> <br/>'
          //LoadingAlert(title, message)
          //createOrderCash("Efectivo")

          if (paymentInfo.integration.id == 8) {
            setCashValidator()
          } else {
            setDetailOrder({ total: totaltopay, code: "0000" })
            handleShowModal()
          }


        } else if (namePayment == 'Credito' || namePayment == 'Transf./Deposito a cta. Bancaria') {
          title = 'Generando orden....'
          message = 'Espere por favor....<br/> <br/>'
          LoadingAlert(title, message)
          formatDataOrder(0, true)
        } else if (namePayment == 'Yappy') {
          setShowModalPhone(true)
          setChange(0);
        } else if (namePayment == 'Yappy QR') {
          setShowModalProcess(true);
          GenerateYappyTransaction()
        } else if (namePayment == "Mixto") {
          setAmountPending((parseFloat(totaltopay).toFixed(2) - parseFloat(amountPaymentReady).toFixed(2)))
          setShowModalMixto(true)

        } else {
          if (paymentInfo.integration.id == 1) {

            requestPyament();
          } else if (paymentInfo.integration.id == 3) {

            setPaymentManual(true)
          } else if (paymentInfo.integration.id == 6) {

            //We check if the payment is cash 
            if (namePayment == 'Cash') {
              //We continue the cash process payment 
              setDetailOrder({ total: totaltopay, code: "0000" })
              handleShowModal()
            } else {
              let cashback = paymentInfo.params.find((element) => element.name === "iscashback");
              //We check if the cashbak is enabled
              if (cashback !== undefined && cashback.value === "yes") {
                setCashbackModal(true);
              } else {
                requestPaymentEvertech(paymentInfo);
              }
            }
          } else if (paymentInfo.integration.id == 4) {

            requestPaymentBanesco(paymentInfo);
          }

          setChange(0);
        }

        setTimeout(() => {
          setTempMethodPayment(1);
        }, 15000);
      } else {
        ErrorAlert("No hay productos en el carrito", "Agrega un producto", "info");
      }

    } else {
      ErrorAlert("No hay metodo de pago.", "Selecciona un metodo de pago", "info");
      setBotonDeshabilitado(false)
    }
  }

  //decimal reduction
  const decimalReduction = (value) => {

    let string = value.toString()
    let arrayString = string.split(".");
    let newDecimalString = []
    let sample = ''
    if (arrayString[1] != undefined) {
      newDecimalString = arrayString[1].slice(0, 2);
      sample = arrayString[0] + "." + newDecimalString

    } else {
      sample = string;
    }

    let endValue = parseFloat(sample)
    return endValue
  }

  //genrate yappy transaction
  const GenerateYappyTransaction = async () => {
    if (statePayment == false) {
      setStatePayment(true)
      LoadingAlert()
      let token = localStorage.getItem('x-access-machine-token');
      let machine = JSON.parse(localStorage.getItem('machine'));
      let data = {
        "machine_id": machine.id,
        "total": decimalReduction(totaltopay).toString(),
        "subtotal": decimalReduction(totaltopay).toString(),
        "tax": "0",
        "discount": "0",
        "transaction_code": orderNumber,
        "description": "Smartpay - orden:" + orderNumber,
        "params": paymentInfo.params
      }
      try {
        const response = await YappyFetchAPI.newYappyQr(data, token)
        setStatePayment(false)
        ErrorAlert("", "Todo listo para que realices el pago", "info")
        setDataYappy(response.data);
        setYappy_transaction_id(response.data.yappy_transaction.body.transactionId)
        setDataHash(response.data.yappy_transaction.body.hash)
        setModalYappyQr(true)
        setStatusRequestYappy(true)
        //getYappyTransaction(response.data)

      } catch (err) {
        setStatePayment(false)
        showApiError(err, {
          title: "Yappy no esta disponible",
          message: "No se pudo generar la transaccion Yappy.",
          context: `order=${orderNumber}`,
          icon: "warning",
        }, ErrorAlert)

      }
    } else {

    }
  }

  const hadleCancelYappy = (text) => {

    if (text != undefined) {
      setPaymentApproval({ status: 2, description: text });
    } else {
      setPaymentApproval({ status: 2, description: "CANCELADO" });
    }

    setYappy_transaction_id("")
    setModalYappyQr(false);
    setStatusRequestYappy(false)

    setTimeout(() => {
      setShowModalProcess(false);
      setPaymentInfo({ payment: "", payment_id: 0 })

      setPaymentApproval({ status: 0, description: "Procesando pago..." })
    }, 3000);
  }

  // Function to get yappy transaction status
  const getYappyTransaction = async () => {
    let token = localStorage.getItem('x-access-machine-token');

    try {
      let yappy_transaction_id = dataYappy.yappy_transaction.body.transactionId

      const response = await YappyFetchAPI.getYappyTransaction(yappy_transaction_id, token);

      let status = response.data.yappy_transaction.body.status;

      switch (status) {
        case 'PENDING':

          break;

        case 'COMPLETED':


          setModalYappyQr(false)
          setStatusRequestYappy(false)
          setPaymentApproval({ status: 1, description: "APROBADO" })
          setShow(false)
          setTimeout(() => {

            formatDataOrder(yappy_transaction_id, true)
            setShowModalProcess(false);
            setPaymentApproval({ status: 0, description: "Procesando pago..." })
          }, 3000);

          break;

        case 'DECLINED':
          setPaymentInfo({ payment: "" })
          setDataHash("")
          setYappy_transaction_id("")
          hadleCancelYappy('DECLINED')

          break;

        case 'EXPIRED':
          setPaymentInfo({ payment: "" })
          setDataHash("");
          setYappy_transaction_id("")
          hadleCancelYappy('EXPIRED')
          break;

        case 'FAILED':
          setPaymentInfo({ payment: "" })
          setDataHash("")
          setYappy_transaction_id("")
          hadleCancelYappy('FAILED')
          break;

        case 'VOIDED':
          setPaymentInfo({ payment: "" })
          setDataHash("")
          setYappy_transaction_id("")
          hadleCancelYappy('VOIDED')
          break;

      }

    } catch (err) {

      setPaymentInfo({ payment: "" })
      setDataHash("")
      setYappy_transaction_id("")
      hadleCancelYappy("ERROR DE CONSULTA")
    }

  }

  //next step phone number yappy
  const nextStepYappy = (btnYappy, phoneClientYappy, event) => {
    //We check if the event is create and make the request for the yappy btn order
    if (event === "create") {
      //request Yappy btn order
      requestYappyBtnOrder(btnYappy, phoneClientYappy)
    } else
      //We make the denied work flow
      if (event === "DENIED") {
        setShowModalProcess(true);
        setShowModalPhone(false);
        setPaymentApproval({ status: 2, description: "Pago rechazado por el usuario" })
        setTimeout(() => {
          setShowModalProcess(false);
          //We reset the page 
          window.location.reload();
        }, 3000);
      } else
        //We make the expired work flow
        if (event === "EXPIRED") {
          setShowModalProcess(true);
          setShowModalPhone(false);
          setPaymentApproval({ status: 2, description: "Pago expirado" })
          setTimeout(() => {
            setShowModalProcess(false);
            //We reset the page
            window.location.reload();
          }, 3000);
        } else {
          let generalData = localStorage.getItem("generalData");
          let paymentInfo = {}
          AlertSmall("Pago realizado con exito", "success")

          //We check if the general data is a string and parse it to an object
          if (generalData && generalData !== null && generalData !== undefined) {
            generalData = JSON.parse(generalData);
            let params = generalData[0].data.paymentMethods.find(payment => payment.payment === "Yappy");
            //We check if the params of yappy btn are defined
            paymentInfo = params
          }
          setPaymentApproval({ status: 1, description: "Realizado" });
          setShowModalProcess(true);
          setShow(false);
          setShowModalPhone(false);
          setTimeout(() => {
            localStorage.removeItem("OrderDetails");
            setShowModalProcess(false);
          }, 3000);
        }

  }

  //Function to request a yappy btn order 
  const requestYappyBtnOrder = async (btnYappy, phoneClientYappy) => {
    try {
      const response = await YappyFetchAPI.newYappyBtnOrder({
        "params": [],
        "total": totaltopay.toFixed(2),
        "subtotal": subtotal.toFixed(2),
        "taxes": tax.toFixed(2),
        "discount": discount.toFixed(2),
        "transaction_code": orderNumber,
        "description": "Smartpay - orden:" + orderNumber,
        "phone": phoneClientYappy,
        "machine_id": machine.id,
      }, localStorage.getItem('x-access-machine-token'));



      //We check the response of yappy 
      if (response.data.yappy_order && response.data.yappy_order.body.documentName && response.data.yappy_order.body.transactionId) {
        const params = {
          transactionId: response.data.yappy_order.body.transactionId,
          documentName: response.data.yappy_order.body.documentName,
          token: response.data.yappy_order.body.token
        }
        //We check the btn yappy
        if (btnYappy && typeof btnYappy.eventPayment === "function") {
          btnYappy.eventPayment(params);
        }

        //We create a temporal order of yappy
        createPreOrder(null, params)

        AlertSmall("Revisa tu yappy en pendientes", "info")
      }
    } catch (err) {

      setPaymentApproval({ status: 2, description: "Algo salio mal" });
      setShow(false);
      setTimeout(() => {
        setShowModalProcess(false);
      }, 3000);
    }
  }

  //create preOrder
  const createPreOrder = async (payment, yappyParams) => {
    if ((shoppingCart.length + shoppingCartCombos.length) > 0) {
      LoadingAlert()
      let token = localStorage.getItem('x-access-machine-token');
      let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
      let machine = JSON.parse(localStorage.getItem('machine'))
      let user = JSON.parse(localStorage.getItem('user'));

      let json = {
        "client_name": "Cliente generico",
        "localizador": "00",
        "client_phone": "0",
        "ruc": "0000",
        "dv": "00",
        "client_id": 0,
        "dgi_qr": "0",
        "Orden": shoppingCart,
        "combos": shoppingCartCombos,
        "Descuento": discount,
        "Total": total,
        "itbms": tax,
        "taxes": taxesArrayAll,
        "subtotal": subtotal,
        "machine_id": machine.id,
        "branchoffice_id": branchoffice.id,
        "tipoOrden": "para llevar",
        "paymethod": 0,
        "is_discount_notification": false,
        "is_cupon": false,
        "is_devolution_notification": false,
        "is_pre_order": true,
        "user": {
          id: user.id,
          name: user.name,
          code: user.user_code
        },
        waiter: {
          "id": selectedWaiter?.id ?? 0,
          "name": selectedWaiter?.user_name ?? null,
          "code": selectedWaiter?.user_code ?? null,
        },
        "table_name": tableInfo.name,
        "table_code": tableInfo.table_code,
        "table_id": tableInfo.id,
        "table_password": tableInfo.password,

      }

      //We check if the params of yappy comes
      if (yappyParams !== undefined) {
        json.is_yappy_pay = true
        json.yappy_transaction_id = yappyParams.transactionId
        json.yappy_document_name = yappyParams.documentName
        json.yappy_order_token = yappyParams.token

        localStorage.setItem("yappy_transaction_id", yappyParams.transactionId);

        json.paymenthod_id = 6;
        json.paymenthod = "Yappy";
        json.paymenthod_integration_id = 2;
      }


      try {
        const response = await PreOrderFetchAPI.createPreOrder(json, token)
        let message = "Pago creado con exito."
        let title = "Operacion exitosa."
        let icon = "success"
        //AlertSmall(message, icon)
        //setShowModalConfirmation(false)
      } catch (err) {
        showApiError(err, {
          title: "No se pudo crear la precuenta",
          message: "El pago fue aprobado, pero no se pudo crear la precuenta asociada.",
          context: `order=${orderNumber} yappy=${yappyParams?.transactionId || "no"}`,
        }, ErrorAlert)
      }
    } else {
      ErrorAlert("Debes agregar  algo al carrito", "No hay productos en el carrito", "info")
    }
  }



  //function action print order
  const getPrinter = async () => {
    try {
      const response = await PrinterFetchAPI.getPrinter(localStorage.getItem('x-access-machine-token'), machine.id);

      let arrayPrinters = response.data.printers;
      let printer_Comanda = "";
      let printer_ticket = "";
      let printer_zebra = "";
      let printer_ip = "";
      for (let i = 0; i < arrayPrinters.length; i++) {
        if (arrayPrinters[i].printer_type == 'Tickets') {
          printer_ticket = arrayPrinters[i].printer_name
          printer_ip = arrayPrinters[i].ip || ""
        } else if (arrayPrinters[i].printer_type == 'Comanda') {
          printer_Comanda = arrayPrinters[i].printer_name
        } else if (arrayPrinters[i].printer_type == 'Zebra') {
          printer_zebra = arrayPrinters[i].printer_name;
        }
      }

      const printersWithCategories = await Promise.all(arrayPrinters.map(async (printer) => {
        try {
          const categoriesResponse = await CategriesPosFetchAPI.getCategoriesByPrinters(
            printer.printer_id,
            localStorage.getItem('x-access-machine-token')
          )
          return { ...printer, categories: categoriesResponse.data.categories }
        } catch (err) {
          return { ...printer, categories: [] }
        }
      }))

      setPrinters(printersWithCategories)
      setInfoPrinter({ printer_comanda: printer_Comanda, printer_ticket: printer_ticket, printer_zebra: printer_zebra, printer_ip: printer_ip });

    } catch (err) {

    }
  }


  //function of cash status
  const statusCash = (status) => {
    if (status == 1) {//aprobed

      //We check if the payment is cash evertech 
      if (paymentInfo.integration.id == 6) {
        //We send the request to the evertech payment
        requestPaymentEvertech(paymentInfo);
      } else {
        //We just call the function register order
        formatDataOrder(0, true)
      }
      handleCloseModal();
    } else if (status == 2) {//cancel
      handleCloseModal()
    }
  }

  //get order
  const getLastOrderMachineNow = async () => {
    let token = localStorage.getItem('x-access-machine-token');
    let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
    let business = JSON.parse(localStorage.getItem('business'));

    try {
      const response = await FilterOrderFetchAPI.getLastOrderOfMachine(machine.id, token)
      let order_last_number = orderNumberNow.toString()

      if (order_last_number.length < 4) {
        order_last_number = "0" + order_last_number
      }

      if (order_last_number == response.data.last_order.transaction_code && total == response.data.last_order.total) {
        setModalShowErrorRegisterOrder(false)
        setDataTransaction_code(response.data.last_order.transaction_code)
        setShow(false)
        setResponseQr(true);
        let title = "ORDEN: " + response.data.last_order.transaction_code
        let text = "Total de la orden: $" + total.toFixed(2)

        if (dataPreOrder.pre_Order == true) { deleteTempPreOrder(response.data.last_order.transaction_code, response.data.last_order.order) }
        //ConfirmationAlert(title, text, setPageLoader)
        printOrder(response.data.last_order.order_id, response.data.last_order.transaction_code, undefined, {
          isPreOrderPayment: dataPreOrder.pre_Order === true,
        });
        setTempMethodPayment(0);
        setRegisterTurnOrder(1);

        //We show a success message when the order is approved when the type of payment is credit 
        if (paymentInfo.payment_id === 10) {
          SuccessAlert("Orden a credito generada", "Orden generada", "success")
        } else {
          SuccessAlert("Orden registrada con exito", "Orden generada", "success")
        }
      } else {
        formatDataOrder(0, true)
      }
    } catch (err) {
      setPointsRedeemLoading(false);
      const apiError = normalizeApiError(err, {
        title: "No se pudo consultar la ultima orden",
        message: "No se pudo validar si la orden fue registrada.",
        context: `machine=${machine?.id || ""} order=${orderNumberNow}`,
      });

      if (apiError.message === "No existe la ordern") {
        //registernewOrder(0)
      } else {
        ErrorAlert(apiError.message, apiError.title, apiError.icon, undefined, { detail: apiError.detail })
      }
    }
  }

  const setCashValidator = async () => {//set cash validator

    if (statePayment == false) {
      setStatePayment(true)
      setShowModalProcess(true);
      let data = { "Terminal": "Autoservicio 1", "Monto": totaltopay.toFixed(2), "recibido": "0.00", "cambio": "0.00" }
      try {
        const response = await RequestLocalFetchAPI.postCashMethod(data);
        setStatePayment(false)


        if (response.data.status == "APPROVED") {
          setPaymentApproval({ status: 1, description: "Aprobado" });
          setShow(false);
        } else {
          setPaymentApproval({ status: 2, description: "Error en el validador de efectivo" });

        }

        setTimeout(() => {
          if (response.data.status == "APPROVED") {
            formatDataOrder(0, true)
          } else {
            cancelMethodPayment()
          }

          setShowModalProcess(false);
          setPaymentApproval({ status: 0, description: "Procesando pago..." })
        }, 3000);

      } catch (err) {
        setPaymentApproval({ status: 2, description: "Error en el validador de efectivo" });

        setTimeout(() => {
          cancelMethodPayment()
          setShowModalProcess(false);
          setPaymentApproval({ status: 0, description: "Procesando pago..." })
        }, 3000);
      }
    }
  }

  //function action request pyment local
  const requestPyament = async (yappy_Temp_id) => {
    setShowModalProcess(true);
    let JsonTr = {}

    if (paymentInfo.payment != "Yappy") {
      /* JsonTr = [{
        Tipo: 'SALE',
        Producto: 'COBRAR',
        Itbms: tax.toFixed(2),
        Tips: invoiceTips,
        Descuento: discount.toFixed(2),
        Monto: totaltopay.toFixed(2),
        TipoVenta: paymentInfo.payment.toUpperCase(),
        paymentMethod: paymentInfo,
        orderid: yappy_Temp_id,
        tel: "507" + phoneClientYappy,
        total: totaltopay.toFixed(2),
        subtotal: subtotal.toFixed(2),
        taxes: tax.toFixed(2),
      }]; */

      let methodPayment = ""
      if (paymentInfo.payment == "MasterCard") {
        methodPayment = "MC"
      } else {
        methodPayment = paymentInfo.payment
      }

      JsonTr = [{
        Tipo: 'SALE',
        Producto: 'COBRAR',
        Itbms: tax,
        Descuento: discount.toFixed(2),
        Tips: invoiceTips,
        Monto: totaltopay,
        TipoVenta: methodPayment.toUpperCase(),
        paymentMethod: paymentInfo,
        orderid: orderNumber,
      }];
    }

    if (localStorage.getItem("token_session") !== null && localStorage.getItem("token_session") !== undefined && localStorage.getItem("token_session") !== "") {
      JsonTr[0].SmartpayId = localStorage.getItem("token_session")
    } else {
      let newToken = generateToken()
      JsonTr[0].SmartpayId = newToken
      localStorage.setItem("token_session", newToken)
    }

    try {

      const response_machine = await MachinesFetchAPI.getmachineByid(machine.id, localStorage.getItem('x-access-machine-token'));
      setWindows_ip(response_machine.data.data.windows_ip);

      const response = await RequestLocalFetchAPI.postPaymentMethod(JsonTr, response_machine.data.data.windows_ip);


      setEMVStreamResponse(response.data.data.EMVStreamResponse)
      let responseCode = response.data.data.EMVStreamResponse.responseCode;
      let description = response.data.data.EMVStreamResponse.responseCodeDescription

      if (paymentInfo.payment != "Yappy") {
        if (responseCode == "00") {
          setPaymentApproval({ status: 1, description: description });
          setShow(false);
        } else {
          setPaymentApproval({ status: 2, description: description });
        }
      }

      setTimeout(() => {
        if (paymentInfo.payment != "Yappy") {
          if (responseCode == "00") {
            formatDataOrder(response.data.data.EMVStreamResponse, true)
          } else {
            localStorage.setItem("token_session", generateToken())
            printData(response.data.data, printers)
            cancelMethodPayment()
          }
        }
        setShowModalProcess(false);
        setPaymentApproval({ status: 0, description: "Procesando pago..." })
      }, 3000);

      setBotonDeshabilitado(false);
    } catch (err) {
      cancelMethodPayment()
      showApiError(err, {
        title: "No se pudo procesar el pago",
        message: "El metodo de pago no respondio correctamente.",
        context: `order=${orderNumber} payment=${paymentInfo.payment}`,
      }, ErrorAlert)

    }
  }

  //Function to request the payment with evertech
  const requestPaymentEvertech = async (paymentInfo) => {
    let response;
    //We get the user
    let user = JSON.parse(localStorage.getItem('user'));
    //We show the modal of the process
    setShowModalProcess(true);
    try {
      //We make the request to the evertech in base of the payment info
      if (paymentInfo.payment !== "Nota de credito" && paymentInfo.payment !== "Refund" && paymentInfo.payment !== "EBT Refund" && paymentInfo.payment !== "Cash Refund") {
        //We add to the paymentInfo some data that we need to make the payment
        paymentInfo.sECRStationID = machine.code;
        paymentInfo.sCashierID = user.id;
        paymentInfo.sRefNumber = orderNumberNow;
        paymentInfo.tips = invoiceTips;
        paymentInfo.total = total;
        paymentInfo.subtotal = subtotal;
        paymentInfo.tax = tax;
        paymentInfo.basereducedtax = baseReducedTax;
        paymentInfo.discount = discount;
        paymentInfo.taxes = taxesArrayAll;
        //We make the payment request
        response = await ProcessPayment(paymentInfo);
      } else {
        //We make the refund request
        response = await PaymentOperations({
          operationType: "refund",
          integrationType: 'Evertech',
          params: paymentInfo.params,
          taxes: taxesArrayAll,
          tax: tax,
          discount: discount,
          payment: paymentInfo.payment,
          tips: invoiceTips,
          total: total,
          basereducedtax: baseReducedTax,
          subtotal: subtotal,
          sECRStationID: machine.code,
          sCashierID: user.id,
          sRefNumber: orderNumberNow,
        });
      }

      //We check the response of evertech
      if (response && response.data !== undefined && response.data.response_message === "APPROVED") {
        setPaymentApproval({ status: 1, description: "APROBADO" });
        setShow(false);
        setTimeout(() => {
          formatDataOrder(response.data, true)
          setShowModalProcess(false);
          setPaymentApproval({ status: 0, description: "Procesando pago..." })
        }, 3000);
      } else if (response && response.data !== undefined && response.data.response_message === "PINPAD TIMEOUT") {
        setPaymentApproval({ status: 2, description: "Tiempo agotado" });
        setShowModalProcess(false);
      } else if (response && response.data !== undefined && response.data.response_message === "DUPLICATED TRANSACTION.") {
        setPaymentApproval({ status: 2, description: "Transaccion duplicada" });
        setShow(false);
        setTimeout(() => {
          setShowModalProcess(false);
          setPaymentApproval({ status: 0, description: "Procesando..." })
        }, 3000);
      } else if (response && response.data !== undefined && response.data.response_message === "DECLINED (Incorrect PIN)") {
        //console.log("PIN Incorrecto");
        setPaymentApproval({ status: 2, description: " PIN Incorrecto" });
        setShow(false);
        setTimeout(() => {
          setPaymentApproval({ status: 0, description: "Procesando..." })
          setShowModalProcess(false);
        }, 3000);
      } else if ((response && response.Informacion !== undefined) || (response && response.data && response.data.response_message === "Connection Error - LOGON")) {
        setPaymentApproval({ status: 2, description: "Pin pad no disponible" });
        setShow(false);
        setTimeout(() => {
          setShowModalProcess(false);
          setPaymentApproval({ status: 0, description: "Procesando..." })
        }, 3000);
      }
      else {
        setPaymentApproval({ status: 2, description: response.data.response_message !== undefined ? response.data.response_message : "Declinado, Error inesperado" });
        setShow(false);
        setTimeout(() => {
          setShowModalProcess(false);
          setPaymentApproval({ status: 0, description: "Procesando..." });

          //We check if the payment is EBT
          if ((paymentInfo.payment === "EBT" || paymentInfo.payment === "EBT Cash" || paymentInfo.payment === "EBT Unica" || paymentInfo.payment === "EBT Cash Unica" || paymentInfo.payment === "EBT Cash Advance")) {
            setInsufficientMessage(response.data.receipt_output.merchant + response.data.receipt_output.customer ? response.data.receipt_output.merchant + response.data.receipt_output.customer : null)
            setShowModalInsufficientFunds(true)
          }
        }, 6000);

      }
    } catch (err) {
      // Manejamos el error de manera segura
      console.error("Error durante el proceso de pago:", err);

      // Verificamos si el error tiene una respuesta o si viene formateado correctamente
      if (err.status && err.data) {
        setPaymentApproval({ status: 2, description: "Error: " + err.data });
      } else {
        setPaymentApproval({ status: 2, description: "Error inesperado: " + err.message });
      }

      // Ocultamos el modal de proceso después del error
      setShowModalProcess(false);
    }
  }


  //Function to request the payment with banesco
  const requestPaymentBanesco = async (paymentInfo) => {
    let response;
    //We get the user
    let user = JSON.parse(localStorage.getItem('user'));
    //We show the modal of the process
    setShowModalProcess(true);
    try {
      //We make the request to the evertech in base of the payment info
      if (paymentInfo.payment !== "Nota de credito" && paymentInfo.payment !== "Refund") {
        //We add to the paymentInfo some data that we need to make the payment
        paymentInfo.tips = invoiceTips;
        paymentInfo.total = total;
        paymentInfo.subtotal = subtotal;
        paymentInfo.tax = tax;
        paymentInfo.discount = discount;
        //We make the payment request
        response = await ProcessPayment(paymentInfo);
      } else {
        //We make the refund request
        response = await PaymentOperations({
          operationType: "refund",
          integrationType: 'Banesco',
          params: paymentInfo.params,
          tax: tax,
          discount: discount,
          payment: paymentInfo.payment,
          tips: invoiceTips,
          total: total,
          subtotal: subtotal
        });
      }

      //We check the response of banesco
      if (response && response.data !== undefined && response.data.TxnRspCode === "00") {
        setPaymentApproval({ status: 1, description: "APROBADO" });
        setShow(false);
        setTimeout(() => {
          formatDataOrder(response.data, true)
          setShowModalProcess(false);
          setPaymentApproval({ status: 0, description: "Procesando pago..." })
        }, 3000);
      } else {
        setPaymentApproval({ status: 2, description: response.data.TxnRspCode !== undefined ? `Declinado, error #${response.data.TxnRspCode}` : "Declinado, Error inesperado" });
        setShow(false);
        setTimeout(() => {
          setShowModalProcess(false);
          setPaymentApproval({ status: 0, description: "Procesando..." });
        }, 6000);
      }
    } catch (err) {
      // Manejamos el error de manera segura
      console.error("Error durante el proceso de pago:", err);

      // Verificamos si el error tiene una respuesta o si viene formateado correctamente
      if (err.status && err.data) {
        setPaymentApproval({ status: 2, description: "Error: " + err.data });
      } else {
        setPaymentApproval({ status: 2, description: "Error inesperado: " + err.message });
      }

      // Ocultamos el modal de proceso después del error
      setShowModalProcess(false);
    }
  }

  //create order cash temporal
  let type = 0
  const createOrderCash = async (type_method) => {
    let token = localStorage.getItem('x-access-machine-token');
    let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
    let machine = JSON.parse(localStorage.getItem('machine'))
    type = 0
    let json = {
      "client_name": "Estimado cliente",
      "localizador": "",
      "client_phone": "",
      "dgi_qr": "",
      "Orden": shoppingCart,
      "Descuento": discount,
      "Total": total,
      "itbms": tax,
      "taxes": taxesArrayAll,
      "subtotal": subtotal,
      "machine_id": machine.id,
      "branchoffice_id": branchoffice.id,
      "tipoOrden": "comer aqui",
      "paymethod": paymentInfo.id,
      "is_discount_notification": false,
      "type_method": type_method,
      "transaction_code": orderNumber,


    }

    try {
      const response = await CashTempPosFetchAPI.createTempCash(json, token)

      if (type_method == "Yappy") {

        requestPyament(response.data.newTempOrder.code);
        setOrderNumberTemp({ code: response.data.newTempOrder.code, temp_id: response.data.newTempOrder._id })
      }

      console.log(response);
      getOrdersTempCash();
    } catch (err) {
      showApiError(err, {
        title: "No se pudo crear la orden temporal",
        message: "Se intentara recuperar una orden temporal existente.",
        context: `order=${orderNumber} payment=${type_method}`,
        icon: "warning",
      }, ErrorAlert)
      type = 1
      console.log("Hay una temporal");
      getOrdersTempCash();
      /*let erro_progress = err.response.data.error
      //!Error : Machine has an order in progress
      if (erro_progress === 'La maquina ya tiene una orden en progreso') {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'La máquina ya tiene una orden en progreso',
        })
      }*/
      console.log(err);
    }
  }

  //get order temp cash
  let countGetCash = 0 // count to limit get orders
  const getOrdersTempCash = async () => {

    let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
    let machine = JSON.parse(localStorage.getItem('machine'))
    let business = JSON.parse(localStorage.getItem('business'))
    clearInterval(instervalCash)
    try {
      const response = await CashTempPosFetchAPI.getTempCash(machine.code, business.code, branchoffice.code)
      console.log(response);
      let code = response.data.order.code
      let message = ""
      let title = ""
      let icon = ""

      if (type == 0) {
        if (countGetCash == 0) {
          if (paymentInfo.payment != "Yappy") {
            handleShowModal();
          }
          setDetailOrder(response.data.order);
        }

        if (response.data.order.status_id == 1) {
          if (countGetCash <= 100) {
            instervalCash = setInterval(getOrdersTempCash, 5000)
            countGetCash++
          } else {
            message = "Tiempo de espera agotado"
            title = "Advertencia"
            icon = "warning"

            if (paymentInfo.payment == "Yappy") {
              ventanaYappy.close();
              setPaymentApproval({ status: 3, description: "Tiempo de espera agotado." });
            }
            handleCloseModal()
            updateOrderDiscount(code, 5, message, title, icon)
            countGetCash = 0
          }

          //!Fixed Eroor: Correjir mensjae y  poner loading 
        } else if (response.data.order.status_id == 8) {//order temporal is cancel

          title = "Operacion cancelada"
          message = "Orden temporal cancelada"
          icon = "error"

          setBotonDeshabilitado(false);

          if (paymentInfo.payment == "Yappy") {
            ventanaYappy.close();
            setPaymentApproval({ status: 3, description: "Ocurrio un error." });
          }
          updateOrderDiscount(code, 5, message, title, icon)


        } else if (response.data.order.status_id == 7) {//order temporal is confirm
          message = "El pago fue aprobado."
          title = "Pago exitoso"
          icon = "success"

          if (paymentInfo.payment == "Yappy") {
            ventanaYappy.close();
            setPaymentApproval({ status: 1, description: "Pago exitoso." });
          }

          if (paymentInfo.payment == "Efectivo") {
            setShow(false)
          }
          updateOrderDiscount(code, 3, message, title, icon)

          //function register order
          formatDataOrder(0, true)
        }
      } else if (type == 1) {
        console.log("Consulte la temporal remanante");
        updateOrderDiscount(code, 5, message, title, icon)
      }
    } catch (err) {
      console.log(err);
    }
  }

  //cancel temporal transaction yappy
  const cancelTempYappy = () => {
    let message = "Orden temporal cancelada"
    let title = "Operacion cancelada"
    let icon = "error"
    updateOrderDiscount(orderNumbeTemp.code, 5, message, title, icon)
  }

  //cancel method payment in process
  const cancelMethodPayment = () => {
    setTempMethodPayment(0);
    setPaymentApproval({ status: 0, description: "Procesando pago..." })

    //hidden screen modal 
    setStatePayment(false)
    setShowModalProcess(false);

    //if condition payments
    {/*if (paymentInfo.payment == "Yappy") {
      let message = "Orden temporal cancelada"
      let title = "Operacion cancelada"
      let icon = "error"
      updateOrderDiscount(orderNumbeTemp.code, 5, message, title, icon)
    } else {
      setShowModalProcess(false);
    }*/}
  }

  //function try again yappy
  const try_again_yappy = () => {
    setPaymentApproval({ status: 0, description: "Procesando pago..." })
    requestPyament(orderNumbeTemp.temp_id);
  }

  //update orders temporal discount
  const updateOrderDiscount = async (code, status, message, title, icon) => {
    console.log(code);
    let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
    let business = JSON.parse(localStorage.getItem('business'))

    let jsonUpdate = {
      "order_code": code,
      "business_code": business.code,
      "branchoffice_code": branchoffice.code,
      "status": status
    }
    try {
      const response = await CashTempPosFetchAPI.updateOrderTempCash(jsonUpdate)
      console.log(paymentInfo.payment);

      if (type == 0) {
        if (paymentInfo.payment == "Yappy") {
          setTimeout(() => {
            setShowModalProcess(false);
            setPaymentApproval({ status: 0, description: "Procesando pago..." });
          }, 3000);
        }

        if (status == 5) {
          ErrorAlert(message, title, icon)
        }

      } else if (type == 1) {
        console.log("Solicite crear nuevamente la temporal");
        createOrderCash(paymentInfo.payment)
      }
    } catch (err) {
      console.log(err);
    }
  }

  //function to compare data micros and update
  const handlerComparativeNewData = (ip, RvcRef, employeeNum, host_url, micros_params, token, order_id) => {
    let preOrderComparativeOld = JSON.parse(localStorage.getItem('preOrderComparativeOld'))
    let OrderGroupsOld = preOrderComparativeOld.groups
    let OrderCombosOld = preOrderComparativeOld.combos
    let newGroups = []
    let newCombos = []
    //comparative groups
    shoppingCart.forEach(group => {
      let groupOld = OrderGroupsOld.find(item => item.group_id == group.group_id && item.segments_string == group.segments_string)

      if (groupOld != undefined) {
        if (groupOld.amount != group.amount) {
          let newGroup = groupOld
          newGroup.amount = (group.amount - groupOld.amount)
          newGroup.cantidadItem = (group.amount - groupOld.amount)
          newGroups.push(newGroup)

          console.log(newGroup);
        }
      } else {
        newGroups.push(group)
      }
    });

    //Add string data to compare
    shoppingCartCombos.forEach(combo => {
      let stringdata = combo.combo_id + "";
      combo.setGroups.forEach(setGroup => {
        stringdata += setGroup.set_id;
        setGroup.groups.forEach(group => {
          stringdata += group.group_id;
          group.segments.forEach(segment => {
            stringdata += segment.segment_id + segment.item.item_id;
          });
        });
      });
      combo.combo_string = stringdata;
    });

    //Add string data to compare
    OrderCombosOld.forEach(comboOld => {
      let stringdataOld = comboOld.combo_id + "";
      comboOld.setGroups.forEach(setGroup => {
        stringdataOld += setGroup.set_id;
        setGroup.groups.forEach(group => {
          stringdataOld += group.group_id;
          group.segments.forEach(segment => {
            stringdataOld += segment.segment_id + segment.item.item_id;
          });
        });
      });
      comboOld.combo_string = stringdataOld;
    });

    //==========================================
    //Comparative combos
    shoppingCartCombos.forEach(combo => {
      let comboOld = OrderCombosOld.find(comboOld => comboOld.combo_id == combo.combo_id && comboOld.combo_string == combo.combo_string)

      if (comboOld != undefined) {
        if (comboOld.amount != combo.amount) {
          let newCombo = comboOld
          newCombo.amount = (combo.amount - comboOld.amount)
          newCombo.cantidadItem = (combo.amount - comboOld.amount)
          newCombos.push(newCombo)
        }
      } else {
        newCombos.push(combo)
      }
    });

    let dataUpdateOrder = formatDataMicrosCheck(ip, RvcRef, employeeNum, host_url, newGroups, newCombos, "PUT")
    validTotalsMicros(ip, RvcRef, employeeNum, host_url, micros_params, token, order_id, "PUT", dataUpdateOrder)
  }

  //format data to send to micros
  const formatDataMicrosCheck = (ip, RvcRef, employeeNum, host_url, groups, combos, action) => {
    //Json general format
    let jsonMicrosCheck = {
      RvcRef: RvcRef,
      employeeNum: employeeNum,
      host_url: host_url,
      localMicrosServerIp: ip,
      products: [],
      automatic_payment: 1,
      delivery: false,
      client: { name: name, phone: "00" },
      paymentmethods: [{
        "name": paymentInfo.payment,
        "paymenthod_id": paymentInfo.payment_id,
        "total": total
      }],
    }

    if (action == "PUT") {
      let preOrderOld = JSON.parse(localStorage.getItem('preOrderComparativeOld'))
      jsonMicrosCheck.checkSeq = preOrderOld.micros_reference.checkSeq
      jsonMicrosCheck.checkNum = preOrderOld.micros_reference.checkNum
    }

    let data = []
    //json product format
    groups.forEach(product => {
      let dataDetail = {
        "code": product.group_id,
        "name": product.name,
        "price": product.price,
        "cant": product.amount,
        "tax": product.taxes[0].tax,
        "total_discount": product.discount,
        "exist_product": false,
        "total_product": product.price,
        "external_reference": product.external_reference,
        "type": "product",
      }

      let dataSegments = []
      product.segments.forEach(segment => {
        let detail = {
          "external_reference": segment.external_reference,
          "name": segment.name,
          "amount": segment.amount,
        }
        dataSegments.push(detail)
      })
      dataDetail.condiments = dataSegments
      data.push(dataDetail)
    });


    console.log(combos);
    //----------------------------------------------
    //format combos
    combos.forEach(combo => {
      console.log(combo);
      let dataDetailCombo = {
        "type": "combo",
        "code": combo.combo_id,
        "tax": combo.taxes[0].tax,
        "total_discount": combo.discount,
        "exist_product": false,
        "total_product": combo.price,
        "external_reference": combo.referenced_group.external_reference,
        "price": combo.price,
        "name": combo.name,
        "cant": combo.amount,
        "mainDetail": {},
        "sideDetails": [],
      }
      let setGroupsData = []
      combo.setGroups.forEach(setGroup => {
        setGroup.groups.forEach(group => {
          //json group format
          let dataDetail = {
            "name": group.name,
            "external_reference": group.external_reference,
            "isMainProduct": false,
          }

          let dataSegments = []
          group.segments.forEach(segment => {
            let detail = {
              "external_reference": segment.external_reference,
              "name": segment.name,
              "amount": segment.amount,
            }
            dataSegments.push(detail)
          })
          //add data segments to group
          dataDetail.condiments = dataSegments

          if (setGroup.isMainSetGroup == 1) {
            //add data to main detail
            dataDetail.isMainProduct = true
            dataDetailCombo.mainDetail = dataDetail
          } else {
            //add data to side details
            dataDetail.price = group.price
            dataDetail.cant = group.amount
            dataDetail.total = group.price
            setGroupsData.push(dataDetail)
          }
        })
        //add data side details to combo
        dataDetailCombo.sideDetails = setGroupsData
      })
      //add combo to products
      data.push(dataDetailCombo)
    })
    jsonMicrosCheck.products = data

    //return data format
    return (jsonMicrosCheck)
  }

  //validate totals micros
  const validTotalsMicros = async (ip, RvcRef, employeeNum, host_url, orderData, token, order_id, action, dataUpdateOrder) => {
    let order = formatDataMicrosCheck(ip, RvcRef, employeeNum, host_url, shoppingCart, shoppingCartCombos, action)
    try {
      let data = {
        Ruta: `http://${ip}:9472/api/micros/totals/checks?RvcRef=${RvcRef}&employeeNum=${employeeNum}&host_url=${host_url}`,
        Type: "POST",
        Header: { "x-access-token": token },
        Body: { products: order.products, tips: invoiceTips, localMicrosServerIp: ip }
      }

      console.log(data);

      const response = await RequestLocalFetchAPI.postMicros(data);
      let micros_response = response.data.micros_response.CalculateTransactionTotalsResponse.pTotalsResponse
      dataUpdateOrder.paymentmethods[0].total = micros_response.TotalsTotalDue._text
      //Create and update check in micros
      createCheckMicrosOrderLocal(ip, RvcRef, employeeNum, host_url, dataUpdateOrder, token, order_id, action)
    } catch (err) {
      console.log(err);
    }
  }

  // create transacction in micros
  const createCheckMicrosOrderLocal = async (ip, RvcRef, employeeNum, host_url, orderData, token, order_id, type) => {
    setMicrosModule(1)
    let data = {
      Ruta: `http://${ip}:9472/api/micros/checks?RvcRef=${RvcRef}&employeeNum=${employeeNum}&host_url=${host_url}`,
      Type: type,
      Header: { "x-access-token": token },
      Body: orderData
    }

    console.log(data);
    let micros_response;
    try {
      micros_response = await RequestLocalFetchAPI.postMicros(data);

      try {
        //We validate if the micros response is success
        let params_Micros_Respose = {}
        //determines what type of parameter to look for
        if (type == "PUT") {
          params_Micros_Respose = micros_response.data.micros_response.AddToExistingCheckExResponse
        } else {
          params_Micros_Respose = micros_response.data.micros_response.PostTransactionExResponse
        }

        if (params_Micros_Respose.pTotalsResponse.OperationalResult.ErrorCode._text !== undefined && params_Micros_Respose.pTotalsResponse.OperationalResult.ErrorCode._text === "Success") {
          console.log("vamos a actualizar")
          //We add the data that we want to update 
          let data_to_update = {
            micros_reference: {
              checkNum: params_Micros_Respose.pGuestCheck.CheckNum._text,
              checkSeq: params_Micros_Respose.pGuestCheck.CheckSeq._text,
            }
          }
          //We make the update of the order 
          const response = await OrdersFetchAPI.updateOrder(order_id, data_to_update, token);
        }
      } catch (err) {
        console.log(err)
      }
    } catch (err) {
      console.log(err);
    }
  }


  const formatDataEmail = async (email, Datadgi_url, Nowcufe, ccEmail = null) => {
    let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
    let machine = JSON.parse(localStorage.getItem('machine'));
    let business = JSON.parse(localStorage.getItem('business'));
    let logo = localStorage.getItem('businessLogo');
    let user = JSON.parse(localStorage.getItem('user'));
    let url = Datadgi_url != undefined ? Datadgi_url : dgiUrl
    let cufeData = Nowcufe != undefined ? Nowcufe : cufe

    let newShoppingCart = []

    shoppingCart.forEach(item => {
      newShoppingCart.push({
        ...item,
        price: item.price.toFixed(2),
        total: (item.price * item.amount).toFixed(2)
      });
    });

    let dataEmailJson = {
      "cc": ccEmail && ccEmail !== null ? [ccEmail] : [],
      "template": "order-details-smartpay",
      "subject": business.name + " - " + branchoffice.name + "- Factura " + orderNumber,
      "email": email,
      "branchoffice": {
        "name": branchoffice.name
      },
      "emit": {
        "name": branchoffice.fiscal_name,
        "ruc": branchoffice.ruc,
        "dv": branchoffice.dv

      },
      "business": {
        "name": business.name
      },
      "business_color": dataStyleBusiness?.layaoutColor ? dataStyleBusiness.layaoutColor : "#000000",
      "client": {
        "lastname": "",
        "name": dataClientSelected?.billing_name ? dataClientSelected.billing_name : name,
        "ruc": ruc,
        "dv": dv,
      },
      "created_at": getCurrentDateTime(),
      "discount_total": discount.toFixed(2),
      "invoice_total": total.toFixed(2),
      "is_delivery_order": "",
      "items": newShoppingCart,
      "logo_url": logo,
      "payment_method": paymentInfo.payment,
      "sub_total": subtotal.toFixed(2),
      "tax_total": tax.toFixed(2),
      "tips_total": invoiceTips.toFixed(2),
      "transaction_code": orderNumber,
      "dgi_url": url,
      "cufe": cufeData,
      "aditional_info": aditional_data,
      "client_address": addresDescriptionClientFiscal
    }

    console.log("Data to email", dataEmailJson);
    sendMail(dataEmailJson)
  }

  const formatDataOrder = (detailEMVStreamResponse, register, paymentOverride, clientOverride, extraInfo = {}) => {
    let user = JSON.parse(localStorage.getItem('user'));
    let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
    let machine = JSON.parse(localStorage.getItem('machine'));
    let client = localStorage.getItem('client') !== null && localStorage.getItem('client') !== undefined ? JSON.parse(localStorage.getItem('client')) : null;
    let selectedWaiter = localStorage.getItem("pos_selected_waiter") !== null && localStorage.getItem("pos_selected_waiter") !== undefined && localStorage.getItem("pos_selected_waiter") !== '' ? JSON.parse(localStorage.getItem("pos_selected_waiter")) : null;
    let paymentMethodInfo = paymentOverride || paymentInfo;
    let selectedClientInfo = clientOverride || dataClientSelected;
    let json = {
      "user_id": user.id,
      "EMVStreamResponse": detailEMVStreamResponse,
      "transaction_code": orderNumber,
      "client_name": name,
      "id_Client": 0,
      "ruc": ruc,
      "dv": dv,
      "localizador": locator,
      "client_phone": client_phone,
      "dgi_qr": "0",
      "Orden": shoppingCart,
      "combos": shoppingCartCombos,
      "Descuento": discount,
      "Total": total.toFixed(2),
      "itbms": tax.toFixed(2),
      "tips": invoiceTips,
      "taxes": taxesArrayAll,
      "subtotal": subtotal.toFixed(2),
      "machine_id": machine.id,
      "branchoffice_id": branchoffice.id,
      "tipoOrden": checkDeliveryOrder,
      "paymenthod_info": paymentMethodInfo,
      "paymethod": paymentMethodInfo?.payment_id,
      "paymethods": listPaymentReady,
      "discounts": dataDicountApply,
      "paymenthod_integration_id": paymentMethodInfo?.integration?.id ?? paymentMethodInfo?.integration_id,
      "table_name": tableInfo.table_name,
      "table_id": tableInfo.table_id,
      "table_code": tableInfo.table_code,
      "discounts": dataDicountApply,
      "parthner_order": parthner_order,
      "aproved_register": register == true ? true : false,
      "aditional_info": aditional_data,
      "client_address": addresDescriptionClientFiscal
    }


    if (eventDataState !== null) {
      json.event_id = eventDataState.id
      json.event_name = eventDataState.name;
    }

    if (client_type !== 0) {
      json.client_type = client_type
    }

    console.log("Json:", json);

    if (addressNowLocation !== null) {
      console.log(addressNowLocation);
      json.direction = {
        id: addressNowLocation.id,
        lng: addressNowLocation.lng,
        lat: addressNowLocation.lat
      };
    }

    if (selectedClientInfo != null && selectedClientInfo.id != undefined && selectedClientInfo.id != null) {
      json.id_Client = selectedClientInfo.id;
      json.client_id = selectedClientInfo.id;
    }

    //We check if the waiter is selected in the local storage
    let selectedWaiterStorage =
      localStorage.getItem("pos_selected_waiter") ? JSON.parse(localStorage.getItem("pos_selected_waiter")) : null;

    const waiterToUse = normalizeWaiter(selectedWaiter) ?? normalizeWaiter(selectedWaiterStorage);
    if (waiterToUse) {
      json.waiter = {
        id: waiterToUse.user_id,
        name: waiterToUse.user_name,
        code: waiterToUse.user_code
      }
    }

    //We check if the payment integration is evertech 
    if (paymentMethodInfo?.integration?.id === 6) {
      if (detailEMVStreamResponse.amounts.tip !== undefined) {
        //IF the payment integration is evertech we search the tip info and add it to the order
        json.tips = detailEMVStreamResponse.amounts.tip.split("$")[1];
      }
    }

    if (yappy_transaction_id != "") {
      json.yappy_transaction_id = yappy_transaction_id
    }

    if (extraInfo?.points_payment) {
      json.points_payment = extraInfo.points_payment
      json.aditional_info = [aditional_data, `Pago con puntos: ${extraInfo.points_payment.points} pts`].filter(Boolean).join(" | ")
      json.note = [json.note, "Pago con puntos"].filter(Boolean).join(" | ")
      json.Orden = Array.isArray(json.Orden) ? json.Orden.map((item) => formatPointsOrderItem(item)) : []
      json.combos = Array.isArray(json.combos) ? json.combos.map((item) => formatPointsOrderItem(item)) : []
      json.Descuento = 0
      json.Total = "0.00"
      json.itbms = "0.00"
      json.tips = 0
      json.subtotal = "0.00"
      json.taxes = [getZeroPointsTax()]
    }

    if (dataPreOrder.pre_Order == true) {
      json.pre_order = true
      json.pre_order_code = dataPreOrder.code
      json.status_id = dataPreOrder.status_id
      json.transaction_code = dataPreOrder.transaction_code
    }

    if (checkDeliveryOrder === "delivery") {
      json.direction = {
        id: 0,
        lng: JSON.parse(localStorage.getItem("addressNowLocation")).lng,
        lat: JSON.parse(localStorage.getItem("addressNowLocation")).lat
      }
    }


    //We check if the order is to delivery
    if (checkDeliveryOrder == "delivery") {
      json.delivery = {
        platform: selectedDeliveryRule != null && selectedDeliveryRule != undefined ? selectedDeliveryRule.fee_type === "kilometer" && selectedDeliveryRule?.distance_source !== "haversine" ? selectedDeliveryRule?.distance_source : "smartpay" : "smartpay",
        value: delivery,
        tax: invoiceTaxDeliveryFee,
        taxes: selectedDeliveryRule != null && selectedDeliveryRule != undefined && selectedDeliveryRule.taxes != null && selectedDeliveryRule.taxes != undefined ? selectedDeliveryRule.taxes : [],
      }

      //We check if the delivery rule is asap to send the order to asap
      if (selectedDeliveryRule != null && selectedDeliveryRule != undefined) {
        if (selectedDeliveryRule.fee_type === "kilometer" && selectedDeliveryRule.distance_source != null && selectedDeliveryRule.distance_source === "asap") {
          json.delivery = {
            ...json.delivery,
            details: {
              "branchoffice_id": JSON.parse(localStorage.getItem('generalData'))[0].data.branchoffice.id,
              "type_id": 1,
              "is_personal": 0,
              "is_oneway": 1,
              "source_address": JSON.parse(localStorage.getItem('generalData'))[0].data.branchoffice.direction,
              "source_seller_name": JSON.parse(localStorage.getItem('generalData'))[0].data.branchoffice.name,
              "source_seller_phone": JSON.parse(localStorage.getItem('generalData'))[0].data.branchoffice.phone,
              "special_inst": "1.⁠ ⁠Obligatorio tomar foto de recogida y de entrega de pedidos ",
              "source_lat": JSON.parse(localStorage.getItem('generalData'))[0].data.branchoffice.lat,
              "source_long": JSON.parse(localStorage.getItem('generalData'))[0].data.branchoffice.lng,
              "desti_lat": JSON.parse(localStorage.getItem("addressNowLocation")).lat,
              "desti_long": JSON.parse(localStorage.getItem("addressNowLocation")).lng,
              "desti_address": JSON.parse(localStorage.getItem("addressNowLocation")).additional_info,
              "desti_customer_name": name !== "" ? name : "Cliente",
              "desti_customer_phone": client_phone !== "" && client_phone !== null && client_phone !== undefined && client_phone !== "" && client_phone !== "0000000" ? client_phone : addressNowLocation.phone,
              "dest_special_inst": "1.⁠ ⁠Obligatorio tomar foto de recogida y de entrega de pedidos ",
              "vehicle_type": "bike"
            }
          }
        } else if (selectedDeliveryRule.fee_type === "kilometer" && selectedDeliveryRule.distance_source != null && selectedDeliveryRule.distance_source === "tookan") {

          json.delivery = {
            ...json.delivery,
            details: {
              "branchoffice_id": JSON.parse(localStorage.getItem('generalData'))[0].data.branchoffice.id,
              //"order_id": orderNumber,
              "special_inst": "Obligatorio tomar foto de recogida y de entrega de pedidos",
              "source_seller_phone": JSON.parse(localStorage.getItem('generalData'))[0].data.branchoffice.phone,
              "source_seller_name": JSON.parse(localStorage.getItem('generalData'))[0].data.branchoffice.name,
              "source_address": JSON.parse(localStorage.getItem('generalData'))[0].data.branchoffice.direction,
              "source_lat": JSON.parse(localStorage.getItem('generalData'))[0].data.branchoffice.lat,
              "source_long": JSON.parse(localStorage.getItem('generalData'))[0].data.branchoffice.lng,
              "customer_email": client.email !== undefined ? client.email : "invitado@invitado.com",
              "desti_customer_phone": client_phone !== "" && client_phone !== null && client_phone !== undefined && client_phone !== "" && client_phone !== "0000000" ? client_phone : addressNowLocation.phone,
              "desti_address": JSON.parse(localStorage.getItem("addressNowLocation")).additional_info,
              "desti_customer_name": name !== "" ? name : "Cliente",
              "desti_lat": JSON.parse(localStorage.getItem("addressNowLocation")).lat,
              "desti_long": JSON.parse(localStorage.getItem("addressNowLocation")).lng,
            }
          }
        }
      }
    }



    localStorage.setItem("OrderDetails", JSON.stringify(json));
    if (register == true) {
      registernewOrder(json);
    }

  }



  //Register order aprobed
  const registernewOrder = async (json) => {

    let token = localStorage.getItem('x-access-machine-token')
    LoadingAlert("Registrando orden", "Espere un momento por favor...")


    if (registerTurnOrder == 0) {
      setModalShowErrorRegisterOrder(false)
      let machine = JSON.parse(localStorage.getItem('machine'));
      //We check if the json to register has delivery info
      if (json.delivery != null && json.delivery != undefined) {
        //We prepare the payload for approval workflow
        const approvalPayload = {
          branchoffice_id: json.branchoffice_id,
          order_id: json.transaction_code,
          transaction_code: json.transaction_code,
          metadata: json,
          platform: "ECOMMERCE",
          fulfillment_type: "delivery",
          customer_name: json.client_name || "Cliente",
          customer_phone: json.client_phone || "",
        };

        try {
          // We register the delivery order for approval
          const resp = await DeliveryOrdersFetchAPI.registerDeliveryOrder(
            token,
            approvalPayload
          );

          console.log("la vaina de delivery respondio", resp)
          setDataTransaction_code(resp.data.data.metadata.transaction_code)
          setOrder_id(resp.data.data.order_id)
          setOrderCode(resp.data.data._id)
          setShow(false)
          setTempMethodPayment(0);
          setRegisterTurnOrder(1);
          setResponseQr(true);
          localStorage.setItem("token_session", generateToken())
          localStorage.removeItem("OrderDetails")
          SuccessAlert("Orden de delivery enviada con exito", "Orden generada", "success")
        } catch (err) {
          const apiError = showApiError(err, {
            title: "No se pudo enviar la orden de delivery",
            message: "El backend no pudo registrar la orden pendiente de aprobacion.",
            context: `order=${json?.transaction_code || orderNumber} branch=${json?.branchoffice_id || ""}`,
            includeSupportId: true,
          }, ErrorAlert);

          registerTurnOrder = 0;
          setRegisterTurnOrder(registerTurnOrder)
          setTxtErrorRegisterOrder(apiError.message)
          setModalShowErrorRegisterOrder(true)
        }
      } else {

        try {
          const response = await OrderNumberFetchAPI.registerOrder(json, token)
          localStorage.setItem("token_session", generateToken())
          localStorage.removeItem("OrderDetails")
          localStorage.removeItem("voucher_mixto")
          localStorage.removeItem("mixto_payment_approved")

          if (dataClientSelected?.email != undefined && dataClientSelected?.email != null) {
            formatDataEmail(dataClientSelected.email, response.data.data.dgi_qr, response.data.data.cufe)
          }

          setDgiUrl(response.data.data.dgi_qr);
          setCufe(response.data.data.cufe);
          setDataTransaction_code(response.data.data.transaction_code)
          setOrder_id(response.data.data.order_id)
          setOrderCode(response.data.data.order_code)
          setShow(false)
          setResponseQr(true);
          let title = "ORDEN: " + response.data.data.transaction_code
          let text = "Total de la orden: $" + total.toFixed(2)

          if (json.points_payment?.client_id) {
            try {
              const pointsOrderId = response.data.data.id_order || response.data.data.order_id;
              const pointsResponse = await redeemFrequentShopperPoints({
                clientId: json.points_payment.client_id,
                points: json.points_payment.points,
                orderId: pointsOrderId
              });
              if (pointsResponse.data?.data) {
                setdataClientSelected(pointsResponse.data.data);
                localStorage.setItem('client', JSON.stringify(pointsResponse.data.data));
              }
            } catch (pointsError) {
              setPointsRedeemLoading(false);
              showApiError(pointsError, {
                title: "No se pudieron descontar los puntos",
                message: "La orden fue registrada, pero el canje de puntos no se pudo completar.",
                context: `client=${json.points_payment.client_id} points=${json.points_payment.points} order=${response.data.data.id_order || response.data.data.order_id}`,
              }, ErrorAlert);
              return;
            }
          }

          if (dataPreOrder.pre_Order == true) { deleteTempPreOrder(response.data.data.transaction_code, response.data.data.order_code) }
          //ConfirmationAlert(title, text, setPageLoader)
          console.log("PRODUCTOS COBRADOS: ", shoppingCart);
          console.log("selectedDeliveryRule: ", selectedDeliveryRule);
          const tieneReserva = shoppingCart.find(item => item.type === "reservable");
          // Retorna true si existe al menos una reserva, false si no
          console.log(tieneReserva);
          if (tieneReserva) {
            // Si hay reservas, se ejecuta esta lógica
            console.log("Hay reserva");
            putOrderReservedCode(response.data.data.order_id, response.data.data.transaction_code, response.data.data.id_order, tieneReserva, {
              isPreOrderPayment: json.pre_order === true,
            })
          } else {
            console.log("No hay reserva");
            printOrder(response.data.data.order_id, response.data.data.transaction_code, undefined, {
              isPreOrderPayment: json.pre_order === true,
            });
          }


          setTempMethodPayment(0);
          setRegisterTurnOrder(1);

          //type integration micros
          if (response.data.data.micros_params != null) {
            //params micros
            let micros_params = response.data.data.micros_params;
            let ip = micros_params.localMicrosServerIp
            if (dataPreOrder.pre_Order == true) {

              if (dataReferenceOrderMicros.checkNum != "" && dataReferenceOrderMicros.checkSeq != "") {
                handlerComparativeNewData(ip, micros_params.RvcRef, micros_params.employeeNum, micros_params.host_url, micros_params, token, response.data.data.order_id);
              } else {
                //createCheckMicrosOrderLocal(ip, micros_params.RvcRef, micros_params.employeeNum, micros_params.host_url, micros_params, token, response.data.data.order_id, "POST");
                validTotalsMicros(ip, micros_params.RvcRef, micros_params.employeeNum, micros_params.host_url, micros_params, token, order_id, "POST", micros_params)
              }
            } else {
              //createCheckMicrosOrderLocal(ip, micros_params.RvcRef, micros_params.employeeNum, micros_params.host_url, micros_params, token, response.data.data.order_id, "POST");
              validTotalsMicros(ip, micros_params.RvcRef, micros_params.employeeNum, micros_params.host_url, micros_params, token, order_id, "POST", micros_params)
            }
          } else {
            console.log("no hay parametros de micros");
          }

          //We show a success message when the order is approved when the type of payment is credit 
          if (json.points_payment?.client_id) {
            SuccessAlert("Puntos canjeados correctamente", "Orden generada", "success")
          } else if (paymentInfo.payment_id === 10) {
            SuccessAlert("Orden a credito generada", "Orden generada", "success")
          } else {
            SuccessAlert("Orden registrada con exito", "Orden generada", "success")
          }
          setPointsRedeemLoading(false);
          //We remove the selected waiter when the order is registered
          localStorage.removeItem("pos_selected_waiter_id")
          localStorage.removeItem("pos_selected_waiter")
        } catch (err) {
          //valid to id of transaction 

          const apiError = normalizeApiError(err, {
            title: "No se pudo registrar la orden",
            message: "El backend rechazo el registro de la orden.",
            context: `order=${json?.transaction_code || orderNumber}`,
          });

          if (apiError.message.includes("ocupada")) {
            registerTurnOrder = 0;
            setRegisterTurnOrder(registerTurnOrder)
            ErrorAlert(apiError.message, apiError.title, apiError.icon, undefined, { detail: apiError.detail })
            setTxtErrorRegisterOrder(apiError.message)
            setModalShowErrorRegisterOrder(true)
          } else {
            try {
              let token = localStorage.getItem('x-access-machine-token');
              const response = await MachinesFetchAPI.lastOrderMachine(machine.id, token);

              if (response.data.last_order._id == lastOrder_id) {
                console.log("La transaccion no habia sido regitrada")
                console.log(err);
                registerTurnOrder = 0;
                setRegisterTurnOrder(registerTurnOrder)
                ErrorAlert(apiError.message, apiError.title, apiError.icon, undefined, { detail: apiError.detail })
                setTxtErrorRegisterOrder(apiError.message)
                setModalShowErrorRegisterOrder(true)
                localStorage.removeItem("pos_selected_waiter_id")
                localStorage.removeItem("pos_selected_waiter")
              } else {
                console.log("La transaccion ya habia sido regitrada")
                setDataTransaction_code(response.data.last_order.transaction_code);
                setOrder_id(response.data.last_order.order_id)
                setOrderCode(response.data.last_order.order_code)
                localStorage.setItem("token_session", generateToken())
                localStorage.removeItem("OrderDetails")
                localStorage.removeItem("voucher_mixto")
                localStorage.removeItem("mixto_payment_approved")
                localStorage.removeItem("pos_selected_waiter_id")
                localStorage.removeItem("pos_selected_waiter")
                console.log(response);
                setShow(false)
                setResponseQr(true);
                let title = "ORDEN: " + response.data.last_order.transaction_code
                let text = "Total de la orden: $" + total.toFixed(2)

                if (dataPreOrder.pre_Order == true) { deleteTempPreOrder(response.data.last_order.transaction_code, response.data.last_order.order_code) }
                //ConfirmationAlert(title, text, setPageLoader)
                printOrder(response.data.last_order.order_id, response.data.last_order.transaction_code, undefined, {
                  isPreOrderPayment: dataPreOrder.pre_Order === true,
                });
                setTempMethodPayment(0);
                setRegisterTurnOrder(1);

                //We show a success message when the order is approved when the type of payment is credit 
                if (json.points_payment?.client_id) {
                  SuccessAlert("Orden registrada con pago por puntos", "Orden generada", "success")
                } else if (paymentInfo.payment_id === 10) {
                  SuccessAlert("Orden a credito generada", "Orden generada", "success")
                } else {
                  SuccessAlert("Orden registrada con exito", "Orden generada", "success")
                }
                localStorage.removeItem("pos_selected_waiter_id")
                localStorage.removeItem("pos_selected_waiter")
              }

            } catch (err) {
              const recoveryError = normalizeApiError(err, {
                title: "No se pudo verificar la ultima orden",
                message: apiError.message,
                context: `machine=${machine?.id || ""} order=${json?.transaction_code || orderNumber}`,
              });

              registerTurnOrder = 0;
              setRegisterTurnOrder(registerTurnOrder)
              ErrorAlert(recoveryError.message, recoveryError.title, recoveryError.icon, undefined, { detail: recoveryError.detail })
              setTxtErrorRegisterOrder(recoveryError.message)
              setModalShowErrorRegisterOrder(true)
              localStorage.removeItem("pos_selected_waiter_id")
              localStorage.removeItem("pos_selected_waiter")
            }
          }
        }
      }
    } else {
      console.log("Hay una orden en proceso");
    }
  }

  //Put order with product reserved
  const putOrderReservedCode = async (id_Orden_Imprimir, transaction_code, id_order_mysql, group, printOptions = {}) => {
    try {
      let token = localStorage.getItem('x-access-machine-token');
      let data = {
        "status": "redeemed",
        "order_id": id_order_mysql
      }
      const response = await ReservationFetchAPI.putReservation(group.group_id, data, token)

      printOrder(id_Orden_Imprimir, transaction_code, undefined, printOptions);
    } catch (err) {
      console.log(err);
      printOrder(id_Orden_Imprimir, transaction_code, undefined, printOptions);
    }
  }


  //print order
  const printOrder = async (id_Orden_Imprimir, transaction_code, micros, options = {}) => {
    let type_ticket = ""
    let imprimir_comanda = ""
    let ip_print = "localhost"
    const isPreOrderPayment = shouldUsePreOrderPaymentPrintMode({
      explicitPreOrderPayment: options.isPreOrderPayment,
      preOrderInvoice,
      dataPreOrder,
    });
    const shouldPrintKitchen = !isPreOrderPayment || hasPendingKitchenItems(shoppingCart, shoppingCartCombos, {
      printers,
    });

    if (localStorage.getItem("ip_printer") != "" && localStorage.getItem("ip_printer") != undefined && localStorage.getItem("ip_printer") != null) {
      ip_print = localStorage.getItem("ip_printer")
    }

    if (!shouldPrintKitchen) {
      //type_ticket = "factura_precuenta"
      type_ticket = "factura"
      imprimir_comanda = "no"
    } else {
      type_ticket = "factura"
      imprimir_comanda = "si"
    }

    let arrayPrinters = []
    if (!shouldPrintKitchen) {
      printers.forEach((printer) => {
        if (printer.printer_type == "Tickets") {
          arrayPrinters.push(printer)
        }
      });

    } else {
      printers.forEach((printer) => {
        arrayPrinters.push(printer)
      });
    }

    let JsonImprimir = [{
      "type_ticket": type_ticket,
      "Printers": arrayPrinters,
      "Nombre_maquina_impresora": infoPrinter.printer_ticket,
      "Nombre_cocina_impresora": infoPrinter.printer_comanda,
      "Nombre_zebra_impresora": infoPrinter.printer_zebra,
      "PRINTER_IP": infoPrinter.printer_ip,
      "Id_Orden_Imprimir": id_Orden_Imprimir,
      "token": localStorage.getItem('x-access-machine-token'),
      "transaction_code": transaction_code,
      "amount_item": shoppingCart.length,
      "imprimir_comanda": imprimir_comanda,
    }]


    printOrderData(JsonImprimir)

    try {
      const response_machine = await MachinesFetchAPI.getmachineByid(machine.id, localStorage.getItem('x-access-machine-token'));

      if (micros == true) {
        let dataRequestMicros = {
          "body": JsonImprimir, "method": "POST", "url": "http://localhost:9090/impresion"
        }
        const response = await RequestAlohaFetchAPI.requestLocalIp(dataRequestMicros, response_machine.data.data.windows_ip)
      } else {
        if (ip_print == "localhost") {
          const response = await PrinterFetchAPI.printOrder(ip_print, JsonImprimir, response_machine.data.data.windows_ip)
        } else {
          const response = await PrinterFetchAPI.printByServerMiddle(ip_print, JsonImprimir)
        }
      }


    } catch (err) {
      console.log(err);
    }
  }

  //delete pre order
  const deleteTempPreOrder = async (transaction_code, orden_code, pre_order_code) => {

    let token = localStorage.getItem('x-access-machine-token');
    let branchoffice = JSON.parse(localStorage.getItem('branchoffice'));
    let business = JSON.parse(localStorage.getItem('business'));
    let user = JSON.parse(localStorage.getItem('user'));


    let business_code = business.code
    let branch_code = branchoffice.code
    let order_code_temp = pre_order_code !== undefined ? pre_order_code : dataPreOrder.code

    if (codeParthner != 0) {
      business_code = codeParthner.business_code
      branch_code = codeParthner.branchoffice_code
    }




    let jsonUpdate = {
      "order_code": order_code_temp,
      "business_code": business_code,
      "branchoffice_code": branch_code,
      "deleted": false,
      "status": 3,
      "user_id": user.id,
      "finished_order_transaction_code": transaction_code,
      "finished_order_code": orden_code,
      "justification": dataPreOrder?.orde?.justification || "",
    }

    console.log("dataPreOrder", dataPreOrder);
    try {

      //We save the preorder
      await DeletedTempOrdersFetchAPI.newDeletedTempOrder(jsonUpdate, token);

      const response = await PreOrderFetchAPI.deletePreOrder(jsonUpdate, token)

    } catch (err) {
      console.log(err);
    }

  }

  //get last order in this machine
  const lastOrderMachineRequest = async () => {
    let token = localStorage.getItem('x-access-machine-token');
    try {
      const response = await MachinesFetchAPI.lastOrderMachine(machine.id, token);

      setLastOrder_id(response.data.last_order._id)

    } catch (err) {
      console.log(err)
    }
  }

  //function to get data when load the component
  const functionGetRequest = async (turn) => {
    //Variables 
    let token = localStorage.getItem('x-access-machine-token');
    let branchoffice = localStorage.getItem('branchoffice') !== '' ? JSON.parse(localStorage.getItem('branchoffice')) : ''
    let machine = localStorage.getItem('machine') !== '' ? JSON.parse(localStorage.getItem('machine')) : ''
    try {
      //We check the data on the local storage
      if (machine !== '' && machine !== null && machine !== undefined) {
        getPaymentMethod(machine.id, token)
        if (turn == 1) {
          //getOrderNumber(branchoffice.id, token)
        }

      }

      //------------------------------------------------

    } catch (err) {
      console.log(err);
    }
  }

  const getInventory = async () => {

    let array = []
    shoppingCart.forEach(product => {
      if (product.group_id && product.group_id != null) {
        if (product.group_type == "limited") {
          array.push({ "group_id": product.group_id })
        }
      }
    });
    let data = { "products": array }

    console.log("DATOS PRODUCTOS CON INVENTARIO EN LA SHOPPINDCART", data);
    if (array.length > 0) {
      try {
        const response = await InventoryFechtAPI.getInventoryByProducts(data, localStorage.getItem("x-access-machine-token"))
        let dataInventory = response.data.inventory

        console.log("dataInventory", dataInventory);

        let arrayProducts = []
        shoppingCart.forEach((product, index) => {
          dataInventory.forEach(group => {
            console.log("group", group);
            if (group.group_id === product.group_id) {

              let filter = shoppingCart.filter(group => group.group_id == product.group_id)

              let amountNow = 0
              if (filter.length > 0) {
                filter.forEach(groupFilter => { amountNow = (amountNow + groupFilter.amount) })

              } else {
                amountNow = product.amount
              }


              let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
              let dataFilterBranch = group.branchoffices.find(branch => branch.branchoffice_id == branchoffice.id)

              console.log("dataFilterBranch", dataFilterBranch);

              if (dataFilterBranch == undefined) {
                validQuantity(group.quantity)
              } else {
                if (localStorage.getItem("warehouse") == "" || localStorage.getItem("warehouse") == null || localStorage.getItem("warehouse") == undefined) {
                  let warehouselocal = JSON.parse(localStorage.getItem('warehouse'))

                  let findwarehouse = dataFilterBranch.warehouses.find(warehouse => warehouse.warehouse_id == warehouselocal.id)
                  if (findwarehouse == undefined) {
                    validQuantity(dataFilterBranch.quantity)
                  } else {
                    console.log("findwarehouse", findwarehouse);
                    validQuantity(findwarehouse.quantity)
                  }
                } else {
                  validQuantity(dataFilterBranch.quantity)
                }

              }


              function validQuantity(quantity) {
                if (amountNow <= quantity) {

                } else {
                  let dataProduct = product
                  dataProduct.quantity = quantity
                  dataProduct.index = index

                  arrayProducts.push(dataProduct)

                }
              }

            }
          })


        });

        if (arrayProducts.length > 0) {

          shoppingCart.forEach((item) => {
            let filter = arrayProducts.filter(group => group.group_id == item.group_id)
            let quantity = 0
            if (filter != undefined && filter.length > 0) {
              filter.forEach(group => { quantity = (group.quantity) })
              item.quantity = quantity
            }
          })

          setEventHandler(1)

          ErrorAlert("", "Hay productos que requieren ser revisados", "warning")
          //setdataProductInventoryFauld(arrayProducts)
          //setShowModalDetailInventoryByGroup(true)
        } else {
          nextTransactionStep();
        }
      } catch (err) {
        nextTransactionStep();
        console.log(err);
      }
    } else {
      nextTransactionStep();
    }
  }

  //continue with the flow of the transaction
  function nextTransactionStep() {
    openPaymentFlow()
  }

  const handlePayButtonClick = () => {
    if (hasPendingPreOrderCartChanges === true) {
      ErrorAlert(
        "Debes actualizar la precuenta antes de continuar al pago.",
        "Actualiza la precuenta",
        "warning"
      )
      return
    }

    getInventory()
    console.log("Selected PreOrder:", selectPreOrder)
  }



  const openPaymentFlow = () => {
    formatDataOrder(0)
    setShow(true)
    setPendingOpenPayment(false)
    getPrinter()
    setBotonDeshabilitado(false)
    setPaymentInfo({ payment: "" })
    lastOrderMachineRequest()
    functionGetRequest()
  }

  const handleConfirmWaiter = (waiter) => {
    setSelectedWaiter(waiter ?? null)

    if (pendingOpenPayment === true) {
      openPaymentFlow()
    }
  }


  // If we are paying a PreOrder that already has a waiter, prefill it.
  // This should override the "last cashier selection" so the order keeps its original waiter unless changed.
  useEffect(() => {
    if (!selectPreOrder || selectPreOrder.order === "") return;
    let waiterData = selectPreOrder.waiter ?? selectPreOrder
    const preWaiter = normalizeWaiter(waiterData ?? selectPreOrder.order?.waiter ?? null)
    if (!preWaiter) {
      setSelectedWaiter(null)
      localStorage.removeItem('pos_selected_waiter_id')
      localStorage.removeItem('pos_selected_waiter')

      return
    }

    localStorage.setItem('pos_selected_waiter_id', String(preWaiter.user_id))
    localStorage.setItem('pos_selected_waiter', JSON.stringify(preWaiter))
    setSelectedWaiter({
      id: preWaiter.user_id,
      name: preWaiter.user_name,
      code: preWaiter.user_code
    })
  }, [selectPreOrder])


  useEffect(() => {
    if (recoveryOrderApproved == true) {
      let dataOrderRecovery = JSON.parse(localStorage.getItem("OrderDetails"))
      if (dataOrderRecovery?.waiter) {
        setSelectedWaiter({
          id: dataOrderRecovery.waiter.id,
          name: dataOrderRecovery.waiter.name,
          code: dataOrderRecovery.waiter.code
        })
      }
      //setShow(true)
      setInvoiceTips(dataOrderRecovery.tips)
      setShoppingCart(dataOrderRecovery.Orden);
      //setShoppingCartCombos(dataOrderRecovery.combos);
      calculateInvoiceTotals(dataOrderRecovery.Orden, dataOrderRecovery.combos)
      setOrderToRecovery(dataOrderRecovery)
      /*setTimeout(() => {
        registernewOrder(dataOrderRecovery);
      }, [1500])*/

    }
  }, [recoveryOrderApproved]);

  useEffect(() => {
    (async () => {
      functionGetRequest(1)
    })();
  }, [])

  useEffect(() => {
    let timer = 0
    if (statusRequestYappy == true) {
      timer = setInterval(async () => getYappyTransaction(), 5000); //INTERVAL GET YAPPY STATUS TRANSACTION

      return () => clearInterval(timer)
    } else {
      return () => clearInterval(timer) //CLEAR INTERVAL
    }

  }, [statusRequestYappy, dataYappy]);

  //Hook of the webhook of evertech transactions place to play
  useEffect(() => {
    let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
    //We verify the machine code 
    if (machine !== undefined && machine !== null && branchoffice !== undefined && branchoffice !== null) {
      // Connection with the sockets server
      const socket = Socket({ "machine_code": machine.code, "branchoffice_code": branchoffice.code });

      //We listen the yappy order
      socket.on("yappyorder", (data) => {
        let yappyTransactionId = localStorage.getItem('yappy_transaction_id');
        console.log(data);
        //We check if the transaction is the same
        if (yappyTransactionId === data.yappy_transaction_id) {
          setRegisterTurnOrder(1);
          if (hasPreOrderCode(data.pre_order_code)) {
            deleteTempPreOrder(data.transaction_code, data.code, data.pre_order_code)
          }

          setDataTransaction_code(data.transaction_code)
          setOrder_id(data.order_id)
          setOrderCode(data._id)
          setShow(false)
          setTempMethodPayment(0);
          setRegisterTurnOrder(1);
          setResponseQr(true);
          //We print the order
          printOrder(data._id, data.transaction_code, undefined, {
            isPreOrderPayment: hasPreOrderCode(data.pre_order_code),
          });
          //We clear the session
          localStorage.setItem("token_session", generateToken())
          localStorage.removeItem("OrderDetails")
          localStorage.setItem("yappy_transaction_id", "")
        }

      })

      return () => {
        socket.disconnect();
      }
    }
  }, [statePayment, paymentApproval])
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [fullscreen, setFullscreen] = useState(true);
  // o controlado, si quieres el monto en tu estado:
  const [cashInput, setCashInput] = useState('');





  //  ESTADOS NUEVOS(solo UI):
  const [payStep, setPayStep] = useState(0);          // índice dentro de `steps` (0-based)
  const [showPayDetail, setShowPayDetail] = useState(false);

  //  DEFINE ARRIBA DEL return (dentro del componente), justo antes del < Modal >:
  const waitersEnabled = localStorage.getItem("branchoffice") && JSON.parse(localStorage.getItem("branchoffice")).waiters_enabled === 1;
  const allSteps = [
    { key: 'desglose', label: 'Desglose', show: true },
    { key: 'propina', label: 'Propina', show: !isPointsPayment && (waitersEnabled || moduleTips == 1) },
    { key: 'localizador', label: 'Localizador', show: !isPointsPayment && showModuleLocator == true },
    { key: 'paisanitos', label: 'Paisanitos', show: !isPointsPayment && business.id == 13 },
    { key: 'pago', label: 'Pago', show: true },
  ];
  const steps = allSteps.filter(s => s.show);
  const stepKey = steps[payStep]?.key;
  const isLast = payStep >= steps.length - 1;
  const isFirst = payStep <= 0;


  return (
    <>

      <button
        disabled={shoppingCart.length == 0 ? true : false}
        className=' px-5 bw-100 border-0'
        onClick={handlePayButtonClick}>
        <strong className='fs-label-1'>{isPointsPayment ? "Pagar con puntos: " : "Pagar: "}</strong>
        <strong className='fs-label-1' translate='no'>{isPointsPayment ? `${pointsTotal} pts` : `$${total.toFixed(2)}`}</strong>
      </button>

      <Modal
        show={show}
        fullscreen
        centered
        onHide={() => setShow(false)}
        dialogClassName="sp-pay-dialog"
        contentClassName="sp-pay-content"
      >
        <Modal.Body className="sp-pay2">

          {/* ===== HEADER + STEPPER dinámico ===== */}
          <header className="sp-pay2__head">
            <h2 className="sp-pay2__title">Procesar pago</h2>

            <div className="sp-pay2__steps" role="tablist" aria-label="Pasos del pago">
              {steps.map((s, i) => (
                <React.Fragment key={s.key}>
                  {i > 0 && <span className="sp-pay2__stepline" aria-hidden="true"></span>}
                  <button
                    type="button"
                    className={`sp-pay2__step ${payStep === i ? 'is-active' : ''} ${payStep > i ? 'is-done' : ''}`}
                    onClick={() => setPayStep(i)}
                  >
                    <span className="sp-pay2__stepnum">{payStep > i ? <i className="uil uil-check"></i> : (i + 1)}</span>
                    <span className="sp-pay2__steplabel">{s.label}</span>
                  </button>
                </React.Fragment>
              ))}
            </div>

            <button className="sp-pay2__x" type="button" aria-label="Cerrar"
              onClick={() => (setShow(false), localStorage.setItem("token_session", generateToken()))}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
            </button>
          </header>

          {/* ===== CUERPO ===== */}
          <div className="sp-pay2__body">

            {/* ---------- PASO: DESGLOSE (cliente + ticket) ---------- */}
            {stepKey === 'desglose' && (
              <div className="sp-pay2__pane">
                <div className="sp-pd">
                  {/* IZQUIERDA: cliente + ticket */}
                  <div className="sp-pd__left">

                    <div className="sp-pd__ticket">
                      <div className="sp-pd__sectlabel">Detalle de la transacción</div>
                      <div className="sp-pd__items">
                        {shoppingCart.map((product, idx) => (
                          product.type == "separator" ? (
                            <div className="sp-pd__sep" key={"s" + idx}><span>{product.name}</span></div>
                          ) : (
                            <div className="sp-pd__line" key={"p" + idx}>
                              <div className="sp-pd__lineinfo">
                                <span className="sp-pd__lname">{product.name}</span>
                                <span className="sp-pd__lprice" translate="no">$ {Number(product.price).toFixed(2)}</span>
                              </div>
                              <span className="sp-pd__lqty" translate="no">{product.amount}×</span>
                            </div>
                          )
                        ))}
                        {shoppingCartCombos.map((combo, idx) => (
                          <div className="sp-pd__line" key={"c" + idx}>
                            <div className="sp-pd__lineinfo">
                              <span className="sp-pd__lname">{combo.name}</span>
                              <span className="sp-pd__lprice" translate="no">$ {Number(combo.price).toFixed(2)}</span>
                            </div>
                            <span className="sp-pd__lqty" translate="no">{combo.amount}×</span>
                          </div>
                        ))}
                      </div>

                      <div className="sp-pd__perf" aria-hidden="true"></div>

                      {isPointsPayment ? (
                        <div className="sp-pd__totrow sp-pd__totrow--grand">
                          <span>Total puntos</span>
                          <strong translate="no">{pointsTotal} pts</strong>
                        </div>
                      ) : (
                        <div className="sp-pd__totals">
                          <RenderIf isTrue={Number(discount) > 0}>
                            <div className="sp-pd__totrow"><span>Descuento</span><span translate="no">$ {discount.toFixed(2)}</span></div>
                          </RenderIf>
                          <RenderIf isTrue={checkDeliveryOrder === "delivery"}>
                            <div className="sp-pd__totrow"><span>Delivery</span><span translate="no">$ {delivery.toFixed(2)}</span></div>
                          </RenderIf>
                          <div className="sp-pd__totrow"><span>Subtotal</span><span translate="no">$ {subtotal.toFixed(2)}</span></div>
                          <div className="sp-pd__totrow"><span>ITBMS</span><span translate="no">$ {tax.toFixed(2)}</span></div>
                          <div className="sp-pd__totrow sp-pd__totrow--grand"><span>Total</span><strong translate="no">$ {total.toFixed(2)}</strong></div>
                          {invoiceTips > 0 ? (
                            <div className="sp-pd__totrow sp-pd__totrow--tip"><span>Total + Propina</span><strong translate="no">$ {totaltopay.toFixed(2)}</strong></div>
                          ) : null}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* DERECHA: personalizar factura + canje de puntos */}
                  <div className="sp-pd__right">
                    <div className="sp-pd__sectlabel">Ajustes del pedido</div>
                    {/* <button className="sp-pd__cardbtn" onClick={handleEditBillShow}>
                      <span className="sp-pd__cardbtn-l"><i className="uil uil-invoice"></i> Personalizar factura</span>
                      <span className="sp-pd__cardbtn-hint">{name ? `${name}` : "Configurar"} <i className="uil uil-angle-right"></i></span>
                    </button> */}

                    <div className="sp-pd__sectlabel">Datos del cliente</div>
                    <div className="sp-pd__client">
                      <div className="sp-pd__avatar">{(name || "CG").slice(0, 2).toUpperCase()}</div>
                      <div className="sp-pd__clientinfo">
                        <div className="sp-pd__clientname">{name || "Cliente general"}</div>
                        <div className="sp-pd__clientsub">Ruc: {ruc} · DV: {dv}</div>
                      </div>
                      <button className="sp-pd__editbill" onClick={handleEditBillShow}>
                        <i className="uil uil-edit"></i> Personalizar
                      </button>
                    </div>

                    {isPointsPayment && (
                      <div className="sp-pd__points">
                        <div className="sp-pd__group">
                          <div className="sp-pd__grouptitle"><i className="uil uil-favorite"></i> Canje de puntos <span className="sp-pd__pts">{pointsTotal} pts</span></div>
                          {dataClientSelected == null ? (
                            <>
                              <div className="sp-pd__note is-info">Busca un cliente existente o registra uno nuevo antes de finalizar el canje.</div>
                              <ClientPillCard dataClientSelected={dataClientSelected} setdataClientSelected={setdataClientSelected} addressNowLocation={addressNowLocation} setAddressNowLocation={setAddressNowLocation} parthner_order={parthner_order} setShoppingCart={setShoppingCart} calculateInvoiceTotals={calculateInvoiceTotals} enabledOnlineOrder={enabledOnlineOrder} parthners={parthners} selectRestaurant={selectRestaurant} setResetData={setResetData} shoppingCart={shoppingCart} shoppingCartCombos={shoppingCartCombos} setShoppingCartCombos={setShoppingCartCombos} />
                            </>
                          ) : (
                            <>
                              <div className="sp-pd__ptscard">
                                <div className="sp-pd__ptsrow"><span>Cliente</span><strong>{dataClientSelected.name || dataClientSelected.billing_name || "Cliente"}</strong></div>
                                <div className="sp-pd__ptsrow"><span>Email</span><strong>{dataClientSelected.email || "-"}</strong></div>
                                <div className="sp-pd__ptsrow"><span>Puntos disponibles</span><strong className={hasEnoughPointsForOrder(dataClientSelected) ? "is-ok" : "is-bad"}>{getClientAvailablePoints(dataClientSelected)} pts</strong></div>
                                <div className="sp-pd__ptsrow"><span>Puntos a descontar</span><strong className="is-accent">{pointsTotal} pts</strong></div>
                                <div className="sp-pd__ptsrow sp-pd__ptsrow--top"><span>Restante</span><strong>{Math.max(getClientAvailablePoints(dataClientSelected) - Number(pointsTotal || 0), 0)} pts</strong></div>
                              </div>
                              {!hasEnoughPointsForOrder(dataClientSelected)
                                ? <div className="sp-pd__note is-bad">El cliente no tiene puntos suficientes para finalizar esta venta.</div>
                                : <div className="sp-pd__note is-ok">Cliente validado. Puedes finalizar el canje.</div>}
                              <button type="button" className="sp-pay2__btn sp-pay2__btn--ghost"
                                style={{ width: '100%', marginTop: 12 }} onClick={() => { setdataClientSelected(null); handleEditBillShow() }}>Cambiar cliente</button>
                            </>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}

            {/* ---------- PASO: PROPINA (mesero + tips) ---------- */}
            {stepKey === 'propina' && (
              <div className="sp-pay2__pane">
                <div className="sp-step">
                  <div className="sp-step__title"><i className="uil uil-user"></i> Atención y propina</div>

                  <RenderIf isTrue={localStorage.getItem("branchoffice") && JSON.parse(localStorage.getItem("branchoffice")).waiters_enabled === 1}>
                    <div className="sp-pd__group">
                      {/* <div className="sp-pd__grouptitle"><i className="uil uil-users-alt"></i> Mesero</div> */}
                      {/* <button className="sp-pd__select" onClick={() => setShowModalWaiters(true)}>
                        <span>{selectedWaiter != null ? (selectedWaiter.user_name ?? selectedWaiter.name ?? "") : "Seleccionar mesero..."}</span>
                        <i className="uil uil-angle-down"></i>
                      </button> */}


                      <ModalWaiters
                        selectPreOrder={selectPreOrder}
                        showWaiters={showModalWaiters}
                        setShowWaiters={setShowModalWaiters}
                        onConfirmWaiter={handleConfirmWaiter}
                        defaultWaiterId={
                          selectPreOrder?.waiter?.user_id ??
                          selectPreOrder?.waiter?.id ??
                          selectPreOrder?.waiter_id ??
                          selectedWaiter?.user_id ??
                          selectedWaiter?.id ??
                          null
                        }
                      />
                    </div>
                  </RenderIf>

                  <RenderIf isTrue={moduleTips == 1}>
                    <div className="sp-pd__module">
                      <ModuleTips
                        invoiceTips={invoiceTips}
                        setInvoiceTips={setInvoiceTips} recomendationTips={recomendationTips} setEventHandler={setEventHandler}>
                      </ModuleTips>
                    </div>
                  </RenderIf>
                </div>
              </div>
            )}

            {/* ---------- PASO: LOCALIZADOR ---------- */}
            {stepKey === 'localizador' && (
              <div className="sp-pay2__pane">
                <div className="sp-step">
                  <div className="sp-step__title"><i className="uil uil-location-point"></i> Localizador</div>
                  <RenderIf isTrue={showModuleLocator == true}>
                    <div className="sp-pd__module"><ModuleLocator locator={locator} setLocator={setLocator}></ModuleLocator></div>
                  </RenderIf>
                </div>
              </div>
            )}

            {/* ---------- PASO: PAISANITOS (Don Lee) ---------- */}
            {stepKey === 'paisanitos' && (
              <div className="sp-pay2__pane">
                <div className="sp-step">
                  <div className="sp-step__title"><i className="uil uil-users-alt"></i> Paisanitos</div>
                  <RenderIf isTrue={business.id == 13}>
                    <div className="sp-pd__module"><ModalDonlee client_phone={client_phone} setClient_phone={setClient_phone} locator={locator} setLocator={setLocator} dataClient={dataClient} setDataClient={setDataClient}></ModalDonlee></div>
                  </RenderIf>
                </div>
              </div>
            )}

            {/* ---------- PASO: PAGO (métodos) ---------- */}
            {stepKey === 'pago' && (
              <div className="sp-pay2__pane">
                <div className="sp-pg">
                  {/* Total a pagar + Ver detalle (colapsado por defecto; despliega TODO) */}
                  <aside className="sp-pg__total">
                    <div className="sp-pg__total-top">
                      <span className="sp-pg__total-label">Total a pagar</span>
                      <button type="button" className="sp-pg__total-detail" onClick={() => setShowPayDetail(v => !v)}>
                        {showPayDetail ? 'Ver menos' : 'Ver detalle'} <i className={`uil ${showPayDetail ? 'uil-angle-up' : 'uil-angle-down'}`}></i>
                      </button>
                    </div>

                    <div className="sp-pg__total-amount" translate="no">
                      {isPointsPayment ? <>{pointsTotal} <small>pts</small></> : <>$ {total.toFixed(2)}</>}
                    </div>

                    <div className="sp-pg__total-sub">
                      {(shoppingCart.length + shoppingCartCombos.length)} artículos · {name || "Cliente general"}
                    </div>

                    {/* Desglose expandido: TODA la info */}
                    {showPayDetail && (
                      <div className="sp-pg__breakdown">
                        {/* Resumen de productos */}
                        <div className="sp-pg__detitems">
                          {shoppingCart.map((product, idx) => (
                            product.type == "separator" ? null : (
                              <div className="sp-pg__detline" key={"dp" + idx}>
                                <span>{product.amount}× {product.name}</span>
                                <span translate="no">$ {Number(product.price).toFixed(2)}</span>
                              </div>
                            )
                          ))}
                          {shoppingCartCombos.map((combo, idx) => (
                            <div className="sp-pg__detline" key={"dc" + idx}>
                              <span>{combo.amount}× {combo.name}</span>
                              <span translate="no">$ {Number(combo.price).toFixed(2)}</span>
                            </div>
                          ))}
                        </div>
                        <div className="sp-pg__detdivider"></div>

                        {isPointsPayment ? (
                          <div className="sp-pg__brow sp-pg__brow--total"><span>Total puntos</span><span translate="no">{pointsTotal} pts</span></div>
                        ) : (
                          <>
                            <RenderIf isTrue={Number(discount) > 0}>
                              <div className="sp-pg__brow"><span>Descuento</span><span translate="no">$ {discount.toFixed(2)}</span></div>
                            </RenderIf>
                            <RenderIf isTrue={checkDeliveryOrder === "delivery"}>
                              <div className="sp-pg__brow"><span>Delivery</span><span translate="no">$ {delivery.toFixed(2)}</span></div>
                            </RenderIf>
                            <div className="sp-pg__brow"><span>Subtotal</span><span translate="no">$ {subtotal.toFixed(2)}</span></div>
                            <div className="sp-pg__brow"><span>ITBMS</span><span translate="no">$ {tax.toFixed(2)}</span></div>
                            <div className="sp-pg__brow sp-pg__brow--total"><span>Total</span><span translate="no">$ {total.toFixed(2)}</span></div>
                            {invoiceTips > 0 ? (
                              <div className="sp-pg__brow"><span>Total + Propina</span><span translate="no">$ {totaltopay.toFixed(2)}</span></div>
                            ) : null}
                          </>
                        )}
                      </div>
                    )}
                  </aside>

                  {/* Métodos */}
                  <div className="sp-pg__methods">



                    {!isPointsPayment
                      ? <>
                        <div className="sp-pg__sectlabel">Selecciona método de pago</div>
                        {!paymentMethod.length ? (
                          <div className="sp-pg__empty"><i className="uil uil-transaction"></i> No hay métodos de pago disponibles</div>
                        ) : (
                          <PayMethodsCarousel deps={paymentMethod.length}>
                            {paymentMethod.map(option => {
                              const pid = option.id + "payment" + option.id + option.integration.id;
                              return (
                                <div className="sp-pg__method" key={option.id + option.integration.id}>
                                  <input className="sp-pg__radio" type="radio" name="option_payments" id={pid} value={JSON.stringify(option)} onChange={(e) => (selectPayment(e))} />
                                  <label className="sp-pg__methodcard" htmlFor={pid}>
                                    <span className="sp-pg__methodtick" aria-hidden="true">
                                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12" /></svg>
                                    </span>
                                    <span className="sp-pg__methodimg">
                                      <img loading="lazy" src={buildCloudinaryImageUrl({ url: option.img, width: 300, quality: "auto:good", type: "image" }) || empty_img} alt={option.payment} />
                                    </span>
                                    <span className="sp-pg__methodname">{option.payment}</span>
                                    <span className="sp-pg__methodint">{option.integration.name}</span>
                                  </label>
                                </div>
                              );
                            })}
                          </PayMethodsCarousel>
                        )}
                      </>
                      : <></>
                    }

                    {!isPointsPayment
                      ? <>
                        {enabledOnlineOrder === true ? <>
                          <div className="sp-pg__sectlabel">Método de pago Especial</div>
                          <ModalCallCenter
                            checkDeliveryOrder={checkDeliveryOrder}
                            dv={dv} name={name} ruc={ruc}
                            setDv={setDv} setName={setName} setRuc={setRuc}
                            dataResponse={dataResponse} optionalData={optionalData}
                            setDataResponse={setDataResponse} setOptionalData={setOptionalData}
                            shoppingCart={shoppingCart} shoppingCartCombos={shoppingCartCombos}
                            total={total} subtotal={subtotal} tax={tax} discount={discount}
                            setPageLoader={setPageLoader} dataPreOrder={dataPreOrder}
                            taxesArrayAll={taxesArrayAll} cardGroup={cardGroup}
                            dataDicountApply={dataDicountApply} paramsMicros={paramsMicros}
                            parthner_order={parthner_order} dataClientSelected={dataClientSelected}
                            setdataClientSelected={setdataClientSelected} addressNowLocation={addressNowLocation}
                            setAddressNowLocation={setAddressNowLocation} domain={domain} events={events}
                          />
                        </> : <></>}


                      </>

                      : <></>
                    }




                    {isPointsPayment
                      ? <>

                        <div className="sp-sum">
                          <div className="sp-sum__title">Resumen de Compra</div>

                          <RenderIf isTrue={!isPointsPayment}>
                            <div className="sp-sum__row">
                              <span className="sp-sum__k">Descuento</span>
                              <span className="sp-sum__v" translate="no">$ {discount.toFixed(2)}</span>
                            </div>

                            <RenderIf isTrue={checkDeliveryOrder === "delivery"}>
                              <div className="sp-sum__row">
                                <span className="sp-sum__k">Delivery</span>
                                <span className="sp-sum__v" translate="no">$ {delivery.toFixed(2)}</span>
                              </div>
                            </RenderIf>

                            <div className="sp-sum__row">
                              <span className="sp-sum__k">ITBMS</span>
                              <span className="sp-sum__v" translate="no">$ {tax.toFixed(2)}</span>
                            </div>
                          </RenderIf>

                          {isPointsPayment ? (
                            <>
                              <div className="sp-sum__perf" aria-hidden="true"></div>
                              <div className="sp-sum__row sp-sum__row--total">
                                <span className="sp-sum__k">Total puntos</span>
                                <span className="sp-sum__v" translate="no">{pointsTotal} pts</span>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="sp-sum__row">
                                <span className="sp-sum__k">Subtotal</span>
                                <span className="sp-sum__v" translate="no">$ {subtotal.toFixed(2)}</span>
                              </div>

                              <div className="sp-sum__perf" aria-hidden="true"></div>

                              <div className="sp-sum__row sp-sum__row--total">
                                <span className="sp-sum__k">Total a pagar</span>
                                <span className="sp-sum__v" translate="no">$ {total.toFixed(2)}</span>
                              </div>

                              {invoiceTips > 0 ? (
                                <div className="sp-sum__row sp-sum__row--tip">
                                  <span className="sp-sum__k">Total + Propina</span>
                                  <span className="sp-sum__v" translate="no">$ {totaltopay.toFixed(2)}</span>
                                </div>
                              ) : <></>}
                            </>
                          )}
                        </div>

                      </>

                      : <>

                      </>
                    }

                  </div>
                </div>
              </div>
            )}
          </div>

          {/* ===== FOOTER dinámico ===== */}
          <footer className="sp-pay2__foot">
            {!isFirst && (
              <button className="sp-pay2__btn sp-pay2__btn--ghost" onClick={() => setPayStep(payStep - 1)}>
                Regresar
              </button>
            )}

            {!isLast ? (
              <button className="sp-pay2__btn sp-pay2__btn--primary sp-pay2__btn--wide" onClick={() => setPayStep(payStep + 1)}>
                Siguiente
              </button>
            ) : (
              <button
                className="sp-pay2__btn sp-pay2__btn--primary sp-pay2__btn--wide"
                disabled={isPointsPayment && (pointsRedeemLoading || !dataClientSelected?.id || !hasEnoughPointsForOrder(dataClientSelected))}
                onClick={() => (isPointsPayment ? processPointsPayment() : processPayment())}
              >
                {isPointsPayment ? (pointsRedeemLoading ? "Canjeando..." : "Finalizar canje") : "Pagar ahora"}
              </button>
            )}
          </footer>

        </Modal.Body>
      </Modal>



      <div > {responseQr == true ? <ModalConfirmation sendStatus={sendStatus} dataClientSelected={dataClientSelected} formatDataEmail={formatDataEmail} setResponseQr={setResponseQr} orderCode={order_code} setPageLoader={setPageLoader} orderNumber={datatransaction_code} total={total} change={change} setChange={setChange} totaltopay={totaltopay} invoiceTips={invoiceTips} microsModule={microsModule} datatransaction_code={datatransaction_code} order_id={order_id} printOrder={printOrder} isPointsPayment={isPointsPayment} pointsTotal={pointsTotal} /> : ""}</div>


      {/* Modals of validation of invoice  client data on dgi */}


      <Modal show={showEditBill} onHide={handleEditBillClose} centered dialogClassName="sp-bill-dialog" contentClassName="sp-bill-content">
        <Modal.Body className="sp-bill">

          {/* Header */}
          <div className="sp-bill__head">
            <div className="sp-bill__badge"><i className="uil uil-edit"></i></div>
            <h2 className="sp-bill__title">Personalizar factura</h2>
            <button className="sp-bill__x" type="button" aria-label="Cerrar" onClick={handleEditBillClose}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
            </button>
          </div>

          <div className="sp-bill__body">

            {/* Carga de datos / RUC */}
            {dataResponse == false ? (
              <div className="sp-bill__block">
                <span className="sp-bill__label">Carga de datos</span>

                {optionalData == true ? <>
                  <div className="sp-bill__rucline"><b>Ruc:</b> <span>{ruc}</span></div>

                  <div className="sp-bill__card">
                    <div className="sp-bill__field">
                      <label className="sp-bill__flabel">Ingresa un nombre</label>
                      <input className="sp-bill__input" placeholder="Nombre" onChange={(e) => (setName(e.target.value))} />
                    </div>
                    <div className="sp-bill__field">
                      <label className="sp-bill__flabel">Ingresa un dv</label>
                      <input className="sp-bill__input" placeholder="00" onChange={(e) => (setDv(e.target.value))} />
                    </div>
                    <div className="sp-bill__acts">
                      <button className="sp-bill__btn sp-bill__btn--cancel" type="button" onClick={() => (setOptionalData(false))}>Ingresar nuevo ruc</button>
                      <button className="sp-bill__btn sp-bill__btn--info" type="button" onClick={() => (setDataResponse(true))}>Cargar datos</button>
                    </div>
                  </div>
                </> : <>
                  <div className="sp-bill__field">
                    <label className="sp-bill__flabel">Ingresa un nombre</label>
                    <input className="sp-bill__input" placeholder="Nombre" onChange={(e) => (setName(e.target.value))} />
                  </div>

                  <div className="sp-bill__field">
                    <label className="sp-bill__flabel sp-bill__flabel--accent">Ingrese su RUC o cédula</label>
                    <div className="sp-bill__rucrow">
                      <input type="text" className="sp-bill__input" placeholder="0-000-000" onChange={(e) => (setRuc(e.target.value))} />
                      <button className="sp-bill__btn sp-bill__btn--primary" type="button" onClick={() => (validDataClient())}>
                        Validar {contAuthRuc > 0 ? <>nuevamente: {contAuthRuc}</> : <></>}
                      </button>
                    </div>
                  </div>
                </>}
              </div>
            ) : (
              <div className="sp-bill__block">
                <span className="sp-bill__label">Datos de Usuario</span>
                <div className="sp-bill__userdata">
                  <p><span>Nombre:</span> <strong>{name}</strong></p>
                  <p><span>RUC:</span> <b>{ruc}</b> <span className="sp-bill__ms">Dv:</span> <b>{dv}</b></p>
                </div>
                <div className="sp-bill__acts sp-bill__acts--center">
                  <button className="sp-bill__btn sp-bill__btn--ghost" type="button" onClick={() => (setDataResponse(false), setOptionalData(false))}>Ingresar nuevo ruc</button>
                  <button className="sp-bill__btn sp-bill__btn--info" type="button" onClick={() => (setDataResponse(false))}>Cambiar datos</button>
                </div>
              </div>
            )}

            {/* Información adicional */}
            <details className="sp-bill__acc">
              <summary className="sp-bill__accsum">
                <span className="sp-bill__arrow">&#9654;</span> Informacion adicional
              </summary>
              <div className="sp-bill__accbody">
                <div className="sp-bill__field">
                  <label className="sp-bill__flabel">Direccion fiscal</label>
                  <input className="sp-bill__input" placeholder="Ejemplo Calle # etc... " value={addresDescriptionClientFiscal} maxLength={90} onChange={(e) => (setAddresDescriptionClientFiscal(e.target.value))} />
                </div>
                <div className="sp-bill__field">
                  <label className="sp-bill__flabel">Dato adicional</label>
                  <textarea className="sp-bill__input sp-bill__textarea" placeholder="Orden de compra - direccion " value={aditional_data} onChange={(e) => (setAditional_data(e.target.value))}></textarea>
                </div>
              </div>
            </details>

            {/* Buscar cliente */}
            <div className="sp-bill__divider"></div>
            <h2 className="sp-bill__subtitle">O busque su cliente</h2>
            <ClientPillCard dataClientSelected={dataClientSelected} setdataClientSelected={setdataClientSelected} addressNowLocation={addressNowLocation} setAddressNowLocation={setAddressNowLocation} parthner_order={parthner_order} setShoppingCart={setShoppingCart} calculateInvoiceTotals={calculateInvoiceTotals} enabledOnlineOrder={enabledOnlineOrder} parthners={parthners} selectRestaurant={selectRestaurant} setResetData={setResetData} shoppingCart={shoppingCart} shoppingCartCombos={shoppingCartCombos} setShoppingCartCombos={setShoppingCartCombos} />
          </div>

          {/* Footer */}
          <div className="sp-bill__foot">
            <button className="sp-bill__btn sp-bill__btn--cancel" onClick={handleEditBillClose}>Cerrar</button>
            <button className="sp-bill__btn sp-bill__btn--ok" onClick={handleEditBillClose}>Guardar datos de usuario</button>
          </div>

        </Modal.Body>
      </Modal>


      {/* Modal Cashierpost */}
      <Modal
        size="lg"
        centered
        backdrop="static"
        show={modalShow}
        onHide={handleCloseModal}
        dialogClassName="sp-cashm-dialog"
        contentClassName="sp-cashm-content"
      >
        <Modal.Body className="sp-cashm">

          {/* Header */}
          <div className="sp-cashm__head">
            <div className="sp-cashm__badge"><i className="uil uil-money-bill"></i></div>
            <div className="sp-cashm__headinfo">
              <h5 className="sp-cashm__title">Pago en efectivo </h5>
              <div className="sp-cashm__chips">
                <span className="sp-cashm__chip">
                  <i className="uil uil-receipt"></i> Orden: <b>{!datatransaction_code ? "0000" : datatransaction_code}</b>
                </span>
                <span className="sp-cashm__chip sp-cashm__chip--accent">
                  <i className="uil uil-usd-circle"></i> Monto a pagar: <b translate="no">${amountOrder}</b>
                </span>
              </div>
            </div>
            <button className="sp-cashm__x" type="button" aria-label="Cerrar" onClick={handleCloseModal}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
            </button>
          </div>

          {/* Cuerpo: teclado de caja */}
          <div className="sp-cashm__body ">
            <Cashierpost
              setChange={setChange}
              setAmountOrder={setAmountOrder}
              setOrderNumber={setOrderNumber}
              setModalShow={setModalShow}
              order_data={detailOrder}
              statusCash={statusCash}
              paymentInfo={paymentInfo}
            />
          </div>

        </Modal.Body>
      </Modal>


      {/*Process payment Loading Moda showModalProcessl */}
      <Modal
        size="lg"
        centered
        backdrop="static"
        show={showModalProcess}      
      >
        <Modal.Body className="sp-pst border-4">
          <section className="sp-pst__card">

            {/* Procesando */}
            <RenderIf isTrue={paymentApproval.status == 0}>
              <span className="sp-pst__badge is-muted">Método de Pago: {paymentInfo.payment}</span>
              <div className="sp-pst__body">
                <div className="sp-pst__spinner"><img src={loading} width="100" height="100" alt="" /></div>
                <h2 className="sp-pst__title">{paymentApproval.description}</h2>
                {tempMethodPayment == 1 ? (
                  <button className="sp-pst__btn sp-pst__btn--cancel" onClick={() => (cancelMethodPayment())}>Cancelar</button>
                ) : ""}
              </div>
            </RenderIf>

            {/* Éxito */}
            <RenderIf isTrue={paymentApproval.status == 1}>
              <span className="sp-pst__badge is-ok">Método de Pago: {paymentInfo.payment}</span>
              <div className="sp-pst__body">
                <div className="sp-pst__icon is-ok"><img src={checkimg} width="100" height="100" alt="" /></div>
                <h2 className="sp-pst__title">¡Éxito!</h2>
                <p className="sp-pst__msg">Su pago ha sido procesado correctamente.</p>
              </div>
            </RenderIf>

            {/* Cancelado / rechazado */}
            <RenderIf isTrue={paymentApproval.status == 2}>
              <span className="sp-pst__badge is-danger">Método de Pago: {paymentInfo.payment}</span>
              <div className="sp-pst__body">
                <div className="sp-pst__icon is-danger"><img src={cancel} width="100" height="100" alt="" /></div>
                <h2 className="sp-pst__title">{paymentApproval.description}</h2>
                <p className="sp-pst__msg">Por favor, verifique la información e intente nuevamente.</p>
              </div>
            </RenderIf>

            {/* Error con reintento (Yappy) */}
            <RenderIf isTrue={paymentApproval.status == 3}>
              <span className="sp-pst__badge is-danger">Método de Pago: {paymentInfo.payment}</span>
              <div className="sp-pst__body">
                <div className="sp-pst__icon is-danger"><img src={cancel} width="100" height="100" alt="" /></div>
                <h2 className="sp-pst__title">{paymentApproval.description}</h2>
                <p className="sp-pst__msg">Por favor, verifique la información e intente nuevamente.</p>
                <div className="sp-pst__acts">
                  <button className="sp-pst__btn sp-pst__btn--ghost" onClick={() => (cancelTempYappy())}>Volver</button>
                  <button className="sp-pst__btn sp-pst__btn--primary" onClick={() => (try_again_yappy())}>Intentar de nuevo</button>
                </div>
              </div>
            </RenderIf>

          </section>
        </Modal.Body>

      </Modal>


      {/*input phone client */}
      <ModalPhoneSaveYappy showModalPhone={showModalPhone} setShowModalPhone={setShowModalPhone} nextStepYappy={nextStepYappy} phone={ClearPhone(client_phone)} ></ModalPhoneSaveYappy>

      {/*Modal payment manual*/}
      <ModalPaymentManual showPaymentManual={showPaymentManual} setPaymentManual={setPaymentManual} paymentInfo={paymentInfo} formatDataOrder={formatDataOrder} registernewOrder={registernewOrder} statusActivity={true}></ModalPaymentManual>

      {/*Modal error register order */}
      <Modal
        size='lg'
        show={modalShowErrorRegisterOrder}
        onHide={() => setModalShowErrorRegisterOrder(false)}
        backdrop="static"
        centered>
        <Modal.Body>
          <h1 className='text-center m-3'>Lo sentimos ocurrio un error</h1>
          <h5 className='text-center'>{txtErrorRegisterOrder !== "" ? txtErrorRegisterOrder : "La orden no pudo ser registrada"}</h5>
          <div className='d-flex alight-item-center justify-content-center'>
            <button className='m-3 btn btn-danger btn-lg' onClick={() => setModalShowErrorRegisterOrder(false)}> Cancelar </button>
            <button className=' m-3 btn btn-success btn-lg' onClick={() => getLastOrderMachineNow()}> Intentar nuevamente</button>
          </div>
        </Modal.Body>
      </Modal>

      {/** Modal to cashback */}
      <Modal
        show={cashbackModal}
        onHide={() => setCashbackModal(false)}
        backdrop="static"
        centered>
        <Modal.Body>
          <h1 className='text-center m-3'>Ingresar el monto de cashback</h1>
          <input type="text" className='form-control' onChange={e => setCashback(e.target.value)} />
          <div className='d-flex alight-item-center justify-content-center'>
            <button className='m-3 btn btn-danger btn-lg' onClick={() => setCashbackModal(false)}> Cancelar </button>
            <button className=' m-3 btn btn-success btn-lg' onClick={() => {
              //We set the cashback value to the paymentInfo object
              paymentInfo.cashback = cashback;
              //We validate the payment method to make the payment
              if (paymentInfo.integration.id == 6) {
                //We make the payment with the cashback
                requestPaymentEvertech(paymentInfo);
                setChange(0);
                //We close the modal
                setTimeout(() => {
                  setCashbackModal(false)
                  setTempMethodPayment(1);
                }, 15000);
              } else {
                ErrorAlert("", "El metodo de pago no es valido", "error");
                setCashbackModal(false)
              }
            }} > Finalizar</button>
          </div>
        </Modal.Body>
      </Modal>

      <ModalYappyQrPos modalYappyQr={modalYappyQr} setModalYappyQr={setModalYappyQr} dataYappy={dataYappy} setDataHash={setDataHash} setYappy_transaction_id={setYappy_transaction_id} dataHash={dataHash} hadleCancelYappy={hadleCancelYappy} total={total} orderNumber={orderNumber} totaltopay={totaltopay}></ModalYappyQrPos>
      <ModalPaymentMixto showModalMixto={showModalMixto}
        setShowModalMixto={setShowModalMixto}
        paymentMethod={paymentMethod}
        total={totaltopay}
        subtotal={subtotal}
        discount={discount}
        tax={tax}
        orderNumber={orderNumber}
        formatDataOrder={formatDataOrder}
        registernewOrder={registernewOrder}
        listPaymentReady={listPaymentReady}
        setlistPaymentReady={setlistPaymentReady}
        amountPaymentReady={amountPaymentReady}
        setAmountPaymenReady={setAmountPaymenReady}
        shoppingCart={shoppingCart}
        amountPending={amountPending}
        setAmountPending={setAmountPending}
        aprovedManualPaymentacardMixto={0}
        yappy_transaction_id={yappy_transaction_id}
        setYappy_transaction_id={setYappy_transaction_id}
        decimalReduction={decimalReduction}

      ></ModalPaymentMixto>
      {/**Modal of insuficient message */}
      <Modal show={showModalInsufficientFunds} onHide={() => setShowModalInsufficientFunds(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Información</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex alight-item-center justify-content-center">
            <RenderIf isTrue={insufficientMessage !== null}>
              <div>
                <pre>{insufficientMessage}</pre>
              </div>
            </RenderIf>

            <RenderIf isTrue={insufficientMessage === null}>
              <div>
                <pre>No se genero voucher</pre>
              </div>
            </RenderIf>

          </div>
          <div className='row'>
            <div className="d-flex justify-content-center">
              <button className="btn btn-info" onClick={() => setShowModalInsufficientFunds(false)}>Cerrar</button>
              <button className="btn btn-success" onClick={() => setShowModalInsufficientFunds(false)}>imprimir</button>
            </div>
          </div>
        </Modal.Body >
      </Modal >


      {orderToRecovery !== null && <RecoveryOrderApproved recoveryOrderApproved={recoveryOrderApproved} setRecoveryOrderApproved={setRecoveryOrderApproved} registernewOrder={registernewOrder} orderData={orderToRecovery} setOrderToRecovery={setOrderToRecovery}></RecoveryOrderApproved>}


    </>
  )
}

export default ModalPayMet




